import { React, useState, useEffect, useContext, useRef, forwardRef, useCallback } from 'react'
import { Button } from 'bootstrap'
import { faL, faMagnifyingGlass, faPrint, faClipboardList, faPaperPlane, faTable } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFileExcel, faFilePdf, faTrashCan, faEye, faEyeSlash, } from '@fortawesome/free-regular-svg-icons'
import { useSelector, useDispatch } from 'react-redux';
import { faStar, faCircleInfo, faXmark, faPlus, faMinus, faSpinner, faCircleCheck } from '@fortawesome/free-solid-svg-icons'
import { APIConstants, IntelliBillConstants, CommonAPIConstants, FilesAPIConstants, SuperBillConstants, formatDOSDate } from '../utilities/Constants'
import Draggable from 'react-draggable'
import * as XLSX from 'xlsx';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { format } from 'date-fns';
import { FixedSizeList as List } from 'react-window'
import { setClaimId } from '../redux/actions/userActions'



const SuperBill = () => {



    const getCurrentDate = () => {
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, '0');
        const day = String(today.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };


    const today = new Date();


    const formatCurDate = format(today, 'MM/dd/yyyy');

    // Default value for the input is the current date
    const defaultDate = getCurrentDate();
    const defaultFromDate = new Date('1/1/2015');



    const [isHideChecked, setIsHideChecked] = useState(false);
    const [isClosedClaim, setIsClosedClaim] = useState(false);
    const [updatedTabledata, setUpdatedTableData] = useState([]);
    const [error, setError] = useState(null);
    const [startDate, setStartDate] = useState(formatCurDate, defaultFromDate); // State to store start date
    const [endDate, setEndDate] = useState(formatCurDate);     // State to store end date
    const [loading, setLoading] = useState(true);
    const [fromDate, setFromDate] = useState(formatCurDate, defaultFromDate);

    const [ServiceLocations, setServiceLocations] = useState([]);
    const [selectedCMS33a, setSelectedCMS33a] = useState('0');
    const [selectedCMS33b, setSelectedCMS33b] = useState('0');
    const [selectedBillingNPI, setSelectedBillingNPI] = useState('0');
    const [selectedPracticeProvider, setSelectedPracticeProvider] = useState('0');
    const [selectedProvidersCategory, setSelectedProvidersCategory] = useState('0');
    const [selectedSearchFilter, setSelectedSearchFilter] = useState('');
    const [sFilterType, setsFilterType] = useState('');
    const [selectedLocation, setSelectedLocation] = useState('0');
    const [searchByLoaction, setSearchByLocation] = useState('-1');
    const [selectedStatusRadioButton, setSelectedStatusRadioButton] = useState('1');
    const [selectedCheckedRadioButton, setSelectedCheckedRadioButton] = useState('0');
    const [selectedServiceLocation, setSelectedServicelocation] = useState('0');
    const [selectedFilterProvider, setSelectedFilterProvider] = useState('0');
    const [selectedFilterCounselor, setSelectedFilterCounselor] = useState('0');
    const [selectedSuggestion, setSelectedSuggestion] = useState(null);
    const [selectedData, setSelectedData] = useState('');
    const [selectedProviderSuggestion, setSelectedProviderSuggestion] = useState([]);
    const [selectedCPTSuggestion, setSelectedCPTSuggestion] = useState(null);
    const [filteredData, setFilteredData] = useState([]);

    const [locations, setLocations] = useState([]);
    const [cms33aData, setCMS33aData] = useState([]);
    const [cms33bData, setCMS33bData] = useState([]);
    const [providerCategory, setProviderCategory] = useState([]);
    const [searchFilterData, setSearchFilterData] = useState([]);
    const [practiceProvider, setPracticeProvider] = useState([]);
    const [statusRadioButton, setStatusRadioButton] = useState([]);
    const [checkedRadioButton, setCheckedRadioButton] = useState([]);
    const [selectClearinghouse, setSelectClearingHouse] = useState([]);
    const [ClearingHouse, setClearingHouse] = useState('1');
    const [selectClearingHouseVal, setselectClearingHouseVal] = useState('');
    const [BillingNPIs, setBillingNPIs] = useState([]);
    const [rows, setRows] = useState([]);

    const [searchText, setSearchText] = useState('');
    const [searchPatientText, setSearchPatientText] = useState('');
    const [searchProvidersText, setSearchProvidersText] = useState('');
    const [ProviderRoleID, setProviderRoleID] = useState('');

    const [searchInsuranceText, setSearchInsuranceText] = useState('');
    const [selectedFilter, setSelectedFilter] = useState('');
    const [suggestions, setSuggestions] = useState([]);
    const [isTextBoxDisabled, setIsTextBoxDisabled] = useState(false);
    const [issuggestionBoxDisabled, setIsSuggestionBoxDisabled] = useState(true);
    const [sPatID, setSPatID] = useState('0');
    const [sClaimStatus, setsClaimStatus] = useState('0');
    const [sCheckedInStatus, setsCheckedInStatus] = useState('0');
    const [rowsValidation, setRowsValidation] = useState('');
    const [isChecked, setIsChecked] = useState(false);
    const [tableDetails, setTableDetails] = useState([]);
    const [tableInsDetails, setTableInsDetails] = useState([]);
    const [checkEligibility, setCheckEligibility] = useState([]);
    const [selectedClaims, setSelectedClaims] = useState([]);
    const [selectAllDropDown, setSelectAllDropDown] = useState([]);
    const [checkboxes, setCheckboxes] = useState();

    const [searchPatientData, setSearchPatientData] = useState([]);
    const [suggestionProviders, setSuggestionProviders] = useState('');
    const [suggestionInsurance, setSuggestionInsurance] = useState('');
    const [patientList, setPatientList] = useState('');

    const [activeRow, setActiveRow] = useState(null);


    const [selectedRows, setSelectedRows] = useState([]);
    const [selectClearingHouseRow, setSelectClearingHouseRow] = useState([]);
    const [selectedLocationRows, setSelectedLocationRows] = useState([]);
    const [selectedValueLocRows, setSelectedValueLocRows] = useState([]);
    const [UnitChargeRows, setUnitChargeRows] = useState([]);
    const [unitCheckbox, setUnitCheckbox] = useState([]);
    const [diag4AllCheckbox, setDiag4AllCheckbox] = useState([]);
    const [diag3AllCheckbox, setDiag3AllCheckbox] = useState([]);
    const [diag2AllCheckbox, setDiag2AllCheckbox] = useState([]);
    const [diag1AllCheckbox, setDiag1AllCheckbox] = useState([]);
    const [mod3AllCheckbox, setMod3AllCheckbox] = useState([]);
    const [mod2AllCheckbox, setMod2AllCheckbox] = useState([]);
    const [mod1AllCheckbox, setMod1AllCheckbox] = useState([]);
    const [cptAllCheckbox, setCptAllCheckbox] = useState([]);
    const [providerAllCheckbox, setProviderAllCheckbox] = useState([]);
    const [insuranceAllCheckbox, setInsuranceAllCheckbox] = useState([]);
    const [closeClaimChecbox, setcloseClaimChecbox] = useState([]);
    const [closeAllClaimCheckbox, setcloseAllClaimCheckbox] = useState(false);
    const [filteredTableDetails, setFilteredTableDetails] = useState(tableDetails);
    const [providerDataList, setProviderDataList] = useState([]);
    const [cptDataList, setCptDataList] = useState([]);
    const [modDataList, setModDataList] = useState([]);
    const [mod2DataList, setMod2DataList] = useState([]);
    const [mod3DataList, setMod3DataList] = useState([]);
    const [diag1DataList, setDiag1DataList] = useState([]);
    const [diag2DataList, setDiag2DataList] = useState([]);
    const [diag3DataList, setDiag3DataList] = useState([]);
    const [diag4DataList, setDiag4DataList] = useState([]);
    const [selectedInsRows, setSelectedInsRows] = useState([]);
    const [selectedCPTCode, setSelectedCPTCode] = useState([]);
    const [selectedCPTPatientID, setSelectedCPTPatientID] = useState([]);
    const [selectedPatientID, setSelectedPatientID] = useState([]);
    const [selectedDiag1ID, setSelectedDiag1ID] = useState('');
    const [selectedDiag2ID, setSelectedDiag2ID] = useState('');
    const [selectedDiag3ID, setSelectedDiag3ID] = useState('');
    const [selectedDiag4ID, setSelectedDiag4ID] = useState('');
    const [newRows, setNewRows] = useState([]);
    const [counselorAllCheckbox, setcounselorAllCheckbox] = useState([]);
    const [counselorRowcheckbox, setcounselorRowcheckbox] = useState([]);
    const [couCPTAllCheckbox, setcouCPTAllCheckbox] = useState([]);
    const [couCPTRowcheckbox, setcouCPTRowcheckbox] = useState([]);
    const [labCPTAllCheckbox, setlabCPTAllCheckbox] = useState([]);
    const [labCPTRowcheckbox, setlabCPTRowcheckbox] = useState([]);


    const [searchByDOS, setSearchByDOS] = useState('');
    const [searchByPatient, setSearchByPatient] = useState('');
    const [searchByDOB, setSearchByDOB] = useState('');
    const [searchByInsuranceID, setSearchByInsuranceID] = useState('');
    const [searchByProvider, setSearchByProvider] = useState('');
    const [searchByCPT, setSearchByCPT] = useState('');
    const [searchByMod1, setSearchByMod1] = useState('');
    const [searchByMod2, setSearchByMod2] = useState('');
    const [searchByMod3, setSearchByMod3] = useState('');
    const [searchByICD1, setSearchByICD1] = useState('');
    const [searchByICD2, setSearchByICD2] = useState('');
    const [searchByICD3, setSearchByICD3] = useState('');
    const [searchByICD4, setSearchByICD4] = useState('');
    const [searchBySUD, setSearchBySUD] = useState('');
    const [searchByCouCPT, setSearchByCouCPT] = useState('');
    const [searchByLabCPT, setSearchByLabCPT] = useState('');
    const [searchByNurseCPT, setSearchByNurseCPT] = useState('');
    const [searchByNurseName, setSearchByNurseName] = useState('');
    const [searchByInvoice, setSearchByInvoice] = useState('');
    const [searchByCounselor, setSearchByCounselor] = useState('');
    const [searchByLocationName, setSearchByLocationName] = useState('');

    const [selectedCptValue, setSelectedCptValue] = useState('');
    const [selectedMod1Value, setSelectedMod1Value] = useState('');
    const [selectedMod2ListVal, setSelectedMod2ListVal] = useState('');
    const [selectedMod3ListVal, setSelectedMod3ListVal] = useState('');
    const [selectedDiag1List, setSelectedDiag1List] = useState('');
    const [selectedDiag2List, setSelectedDiag2List] = useState('');
    const [selectedDiag3List, setSelectedDiag3List] = useState('');
    const [selectedDiag4List, setSelectedDiag4List] = useState('');

    const [cptValueList, setCptValueList] = useState([]);
    const [mod1List, setMod1List] = useState([]);
    const [mod2List, setMod2List] = useState([]);
    const [mod3List, setMod3List] = useState([]);
    const [diag1List, setDiag1List] = useState([]);
    const [diag2List, setDiag2List] = useState([]);
    const [diag3List, setDiag3List] = useState([]);
    const [diag4List, setDiag4List] = useState([]);

    const [selectedUnitVal, setSelectedUnitVal] = useState("");
    const [syncedValue, setSyncedValue] = useState('');
    const [syncedUnitchargeVal, setSyncedUnitchargeVal] = useState('');

    const [selectedProviderText, setSelectedProviderText] = useState('');
    const [selectedCPTList, setSelectedCPTList] = useState('');
    const [selectedModList, setSelectedModList] = useState('');
    const [selectedMod2Value, setSelectedMod2Value] = useState('');
    const [selectedMod3Value, setSelectedMod3Value] = useState('');
    const [selectedDiag1Value, setSelectedDiag1Value] = useState('');
    const [selectedDiag2Value, setSelectedDiag2Value] = useState('');
    const [selectedDiag3Value, setSelectedDiag3Value] = useState('');
    const [selectedDiag4Value, setSelectedDiag4Value] = useState('');
    const [selectedUnitValue, setSelectedUnitValue] = useState('');
    const [selectedUnitChargeValue, setSelectedUnitChargeValue] = useState('');

    const [selectedTextField, setSelectedTextField] = useState('');
    const [selectedValueField, setSelectedValueField] = useState('');
    const [selectLocationID, setSelectLocationID] = useState('-1');

    const [showSelectErrorModal, setShowSelectErrorModal] = useState(false);
    const [showICDErrorModal, setShowICDErrorModal] = useState(false);
    const [ICDConfirmSaveModal, setICDConfirmSaveModal] = useState(false);

    const [showConfirmSaveModal, setShowConfirmSaveModal] = useState(false);
    const [showApprovalSaveModal, setShowApprovalSaveModal] = useState(false);
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [msgSuccesmodal, setmsgSuccesmodal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [deleteSuccessModal, setDeleteSuccessModal] = useState(false);
    const [closeClaimsModal, setCloseClaimsModal] = useState(false);
    const [showFaxModal, setShowFaxModal] = useState(false);
    const [savedRowCount, setSavedRowCount] = useState(0);
    const [deleteRowCount, setDeleteRowCount] = useState(0);
    const [successTimer, setSuccessTimer] = useState(5000);
    const [buttonClicked, setButtonClicked] = useState([]);
    const [showIcon, setShowIcon] = useState(false);
    const [showFaxError, setShowFaxError] = useState(false);
    const [saveFaxError, setSaveFaxError] = useState(false);
    const [showFaxSaveMsg, setShowFaxSaveMsg] = useState(false);
    const [showFaxConfirmMsg, setShowFaxConfirmMsg] = useState(false);

    const [selectedProviderData, setselectedProviderData] = useState('');
    const [selectedMod1Data, setSelectedMod1Data] = useState('');
    const [selectedMod2Data, setSelectedMod2Data] = useState('');
    const [selectedMod3Data, setSelectedMod3Data] = useState('');

    const [selectedInsurances, setSelectedInsurances] = useState({});
    const [selectedPolicyNumbers, setSelectedPolicyNumbers] = useState({});
    const [policyNumbers, setPolicyNumbers] = useState({});

    const [selectAllRowsChecked, setSelectAllRowsChecked] = useState(false);
    const [selectAllClearingHouseRow, setSelectAllClearingHouseRow] = useState(false);
    const [clearingHouseValues, setClearingHouseValues] = useState({});
    const [savedRows, setSavedRows] = useState([]);
    const [epin, setEpin] = useState('');
    const [verifiedEpin, setverifiedEpin] = useState('');
    const [isEPINVerifiedModal, setIsEPINVerifiedModal] = useState(false);
    const [verificationError, setVerificationError] = useState(null);
    const [isStartOpen, setIsStartOpen] = useState(false);
    const [isEndOpen, setIsEndOpen] = useState(false);

    const [selectAllCloseCheckBox, setSelectAllCloseCheckBox] = useState(false);

    const [isLoading, setIsLoading] = useState(false);
    const [isInStatus, setIsInStatus] = useState('');
    const [policyStatus, setPolicyStatus] = useState({});
    const [loadingRows, setLoadingRows] = useState([]);
    const [patientID, setpatientID] = useState('');
    const [rowState, setRowState] = useState({});
    const [claimID, setClaimID] = useState('');
    const [isHidden, setIsHidden] = useState(false);
    const [insOrPatFilter, setInsOrPatFilter] = useState('');
    const [sortDosDate, setSortDosDate] = useState('asc');
    const [sortPatName, setSortPatName] = useState('asc');
    const [sortLocationName, setSortLocationName] = useState('asc');
    const [selectedProviderRadio, setSelectedProviderRadio] = useState('0');
    const [searchTextID, setSearchTextID] = useState('');
    const [sFilterText, setSFilterText] = useState("");
    const [showPopup, setShowPopup] = useState(false);
    const [popupMessage, setPopupMessage] = useState("");
    const [activeTab, setActiveTab] = useState("provider");
    // 25 / 50 / 75 / 100 / all — doubles as page size, same pattern as
    // ClaimApprovalV2.js's "Show" control.
    const [viewLimit, setViewLimit] = useState("all");
    const [currentPage, setCurrentPage] = useState(1);
    const [selectedSendRows, setSelectedSendRows] = useState([]);
    const dispatch = useDispatch();






    const userData = useSelector((state) => state.user.user);
    console.log('userData:', userData);

    localStorage.setItem('userData', JSON.stringify(userData));


    // const storedUserData = JSON.parse(localStorage.getItem('userData'));


    var userPracticeID = userData ? userData.practiceID : null;

    var userId = userData ? userData.userID : null;

    const sAuthToken = useSelector((state) => state.user.user.sAuthToken);
    console.log('sAuthToken:  ', sAuthToken);



    useEffect(() => {
        document.title = 'SuperBill'

        let timerId;

        if (showSuccessModal || deleteSuccessModal || msgSuccesmodal || isEPINVerifiedModal) {
            // Start the timer when the success modal is shown
            timerId = setTimeout(() => {
                setShowSuccessModal(false);
                setDeleteSuccessModal(false);
                setmsgSuccesmodal(false)
                setIsEPINVerifiedModal(false)
            }, successTimer);
        }


        return () => {
            clearTimeout(timerId);
        };
    }, [showSuccessModal, successTimer, deleteSuccessModal, msgSuccesmodal, isEPINVerifiedModal]);










    const handleFromDateChange = (date) => {

        if (date) {
            const formattedDate = format(date, 'MM/dd/yyyy');
            setFromDate(formattedDate);

            console.log("Selected start date:", formattedDate);
        } else {
            setFromDate(null);
        }
    };







    const handleStartDateChange = (date) => {
        if (date) {
            const formattedDate = format(date, 'MM/dd/yyyy');
            setStartDate(formattedDate);
            setEndDate(formattedDate)
            setIsStartOpen(false)
            console.log("Selected start date:", formattedDate);
        } else {
            setStartDate(null);
        }
    };


    const handleEndDateChange = (date) => {

        if (date) {
            const formattedDate = format(date, 'MM/dd/yyyy');
            setEndDate(formattedDate);
            console.log("Selected End date:", formattedDate);
            setIsEndOpen(false)

        } else {
            setEndDate(null);
        }
    };




    const getMonths = (selectedYear) => {
        const currentYear = new Date().getFullYear();
        const currentMonth = new Date().getMonth();

        return Array.from({ length: 12 }, (v, k) => {
            if (selectedYear === currentYear && k > currentMonth) {
                return null;
            }
            return (
                <option key={k} value={k}>
                    {format(new Date(selectedYear, k), 'MMMM')}
                </option>
            );
        }).filter(option => option !== null);
    };




    const handleStartDoneClick = () => {
        setIsStartOpen(false);
    };





    const handleTodayClick = (dateType) => {
        const today = new Date();

        if (dateType === "start" && startDate) {
            setStartDate(today);
            setEndDate(today);
            setIsStartOpen(false);
        }

        if (dateType === "end" && endDate) {
            setEndDate(today);
            setIsEndOpen(false);
        }
    };



    // Styled via .hv-cal-header / .hv-cal-nav-btn / .hv-cal-select, shared in
    // styles/healthiva/_forms.scss so every page's DatePicker popup gets the
    // same header instead of bare browser controls.
    const renderCalendarHeader = ({ date, changeYear, changeMonth, decreaseMonth, increaseMonth, prevMonthButtonDisabled, nextMonthButtonDisabled }) => {
        const selectedDate = date instanceof Date && !isNaN(date) ? date : new Date();
        const selectedMonth = selectedDate.getMonth();
        const selectedYear = selectedDate.getFullYear();

        return (
            <div className="hv-cal-header">
                <button type="button" className="hv-cal-nav-btn" onClick={decreaseMonth} disabled={prevMonthButtonDisabled}>{"<"}</button>
                <select className="hv-cal-select" value={selectedMonth} onChange={({ target: { value } }) => changeMonth(Number(value))}>
                    {getMonths(selectedYear)}
                </select>
                <select className="hv-cal-select" value={selectedYear} onChange={({ target: { value } }) => changeYear(Number(value))}>
                    {Array.from({ length: 100 }, (v, k) => (
                        <option key={k} value={new Date().getFullYear() - k}>{new Date().getFullYear() - k}</option>
                    ))}
                </select>
                <button type="button" className="hv-cal-nav-btn" onClick={increaseMonth} disabled={nextMonthButtonDisabled}>{">"}</button>
            </div>
        );
    };

    const CalendarContainer = ({ children }) => (
        <div className="hv-cal-container">
            {children}
            <div className="hv-cal-footer">
                <button type="button" className="today-btn" onClick={() => handleTodayClick("end")}>
                    Today
                </button>
            </div>
        </div>
    );


    const CalendarStartContainer = ({ children }) => (
        <div className="hv-cal-container">
            {children}
            <div className="hv-cal-footer">
                <button type="button" className="today-btn" onClick={() => handleTodayClick("start")}>
                    Today
                </button>
            </div>
        </div>
    );





    const convertDateFormat = (dateString) => {
        const [year, month, day] = dateString.split('-');
        return `${month}/${day}/${year}`;
    };







    const handleHideCheckboxChange = () => {
        setIsHideChecked(!isHideChecked);

        if (isHideChecked) {
            // Reset to original dates
            setStartDate(formatCurDate);
            setEndDate(formatCurDate);
        } else {
            // Set FROM date to 1/1/2015 and TO date to the current date
            setStartDate('1/1/2015');
            setEndDate(formatCurDate);
        }
    };



    const handleCloseClaimCheckbox = () => {
        setIsClosedClaim(!isClosedClaim);

    };








    // Api Integration of all Dropdowns

    useEffect(() => {
        const url = `${APIConstants.COMMON_BASE_URL}${IntelliBillConstants.GetIntelliDropDowns}?sInputJSON={PracticeID:${userPracticeID},UserId:${userId} }`;

        fetch(url, {
            method: "GET",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
        })
            .then((response) => {
                if (response.status != 200) {
                    console.log("response.status", response.status);
                } else return response.json();
            })

            .then((data) => {
                // Extract the relevant data from the response
                const parsedData = JSON.parse(data);

                setSelectAllDropDown(parsedData);

                // Populate the dropdowns with the received data
                setLocations(JSON.parse(parsedData.LocationDetails));

                setCMS33aData(JSON.parse(parsedData.CMSbox33aData));
                setCMS33bData(JSON.parse(parsedData.CMSbox33bData));
                setBillingNPIs(JSON.parse(parsedData.PracticeBillingNPIs));
                setServiceLocations(JSON.parse(parsedData.ServiceLocation));
                setPracticeProvider(JSON.parse(parsedData.PracticeProviders));
                setProviderCategory(JSON.parse(parsedData.ProvidersCategories));
                setSearchFilterData(JSON.parse(parsedData.SearchByFilters));
                setStatusRadioButton(JSON.parse(parsedData.StatusRadioButtons));
                setCheckedRadioButton(JSON.parse(parsedData.CheckedInRadioButtons));
                setLoading(false);
            })

            .catch((error) => {
                console.error("Error fetching data: ", error);
            });
    }, [userData]);




    useEffect(() => {
        // Reset values when showFaxDialog is true
        if (showFaxModal) {
            setRows([]);
            resetDialogValues();
        }
    }, [showFaxModal]);



    const resetDialogValues = () => {
        // startDate('');
        setSelectedProviderText('');
        setSelectedCPTList('');
        setSelectedModList(null);
        setSelectedUnitValue('');
        setSelectedUnitChargeValue('');
        setSelectedDiag1Value('');
        setSelectedDiag2Value('');
        setSelectedDiag3Value('');
        setSelectedDiag4Value('');
        setSelectedMod2Value('');
        setSelectedMod3Value('');
        setSaveFaxError(false);
        setShowFaxError(false);
        setShowFaxSaveMsg(false);
    };


    const handleLocationChange = (e, item) => {
        const newSelectedLocation = e.target.value;
        setSearchByLocation(newSelectedLocation || (item.LocationId));
        setSelectLocationID(newSelectedLocation);
        console.log("LocationID", selectLocationID);

        localStorage.setItem('selectedLocation', newSelectedLocation);

    };




    const handleSuggestionSelect = (item) => {
        setSearchText(item.label);
        setSearchTextID(item.val)
        setSelectedData(item.label);

        setSuggestions([]);

        setSPatID(item.val);
        console.log("PatientID>>>>", searchTextID);


    };




    useEffect(() => {
        setSFilterText(searchTextID ? searchTextID : searchText);
    }, [searchTextID, searchText]);



    const handleInputKeyPress = (event) => {
        if (event.key === 'Backspace') {
            // Handle backspace key
            if (searchText === '' && suggestions.length > 0) {
                setSuggestions([]);
                setSPatID('');
                setSearchTextID('')

            } else {
                // Remove the last character from searchText
                const updatedSearchText = searchText.slice(0, -1);
                setSearchText(updatedSearchText);

                // Fetch suggestions based on the selected search filter
                fetchSuggestions(updatedSearchText);
            }
        } else if (event.key !== 'Enter') {
            // Handle other key presses
            setSearchText(event.target.value);
            fetchSuggestions(event.target.value);
        }
    };



    const fetchSuggestions = (text) => {
        setSPatID('');

        if (selectedSearchFilter === 'Pat') {
            fetchPatientNames(text);


        } else if (selectedSearchFilter === 'Insurance') {
            fetchInsuranceCompanies(text);

        } else if (selectedSearchFilter === 'Provider') {
            fetchProviders(text);
        }

        else if (selectedSearchFilter === 'CPT') {
            setSearchTextID('')
            setSearchText(text);
        }

        else if (selectedSearchFilter === '' && searchText === "") {
            setSPatID("")
            handleTableDataClick()
        }
    };




    useEffect(() => {

        setIsTextBoxDisabled(selectedSearchFilter === '');

        setSearchTextID('')
        setSearchText('');
        setSPatID("")

    }, [selectedSearchFilter]);







    const fetchPatientNames = () => {


        var inputJSON = {
            PracticeID: userPracticeID,
            SearchKey: searchText,
            SearchBy: 0,
            isFromLogin: 0
        }

        var sJSONInput = JSON.stringify(inputJSON);
        console.log("input of" + CommonAPIConstants.GetAllPatientNames, inputJSON);

        const url = `${APIConstants.BASE_URL_SEARCH}${CommonAPIConstants.GetAllPatientNames}?sJSONInput=${sJSONInput}`;

        console.log("URL: ", url);

        fetch(url, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        })

            .then((response) => {
                if (response.status != 200) { console.log("response.status", response.status); }
                else return response.json();
            })
            .then(data => {



                const parsedData = JSON.parse(data);

                const patientData = parsedData.Data



                console.log("patientLists of" + CommonAPIConstants.GetAllPatientNames, patientData);

                if (Array.isArray(patientData)) {
                    setSuggestions
                        (patientData.map((item) => ({
                            label: `${item.LastName}, ${item.FirstName}`,
                            val: item.PatientID,
                        })));

                } else {


                    setSuggestions([]);

                    setIsTextBoxDisabled(false);
                }
                console.log("PatientsuggestionsLists", suggestions);

            })
            .catch((error) => {
                console.error('Error fetching patient names:', error);
            });
    };






    const fetchSuggestionPatientNames = () => {


        if (!setSearchPatientText) {
            setSearchPatientData([]);
            return;
        }

        var inputJSON = {
            PracticeID: userPracticeID,
            SearchKey: searchPatientText,
            SearchBy: 0,
            isFromLogin: 0
        }

        var sJSONInput = JSON.stringify(inputJSON);
        console.log("input of" + CommonAPIConstants.GetAllPatientNames, inputJSON);

        const url = `${APIConstants.BASE_URL_SEARCH}${CommonAPIConstants.GetAllPatientNames}?sJSONInput=${sJSONInput}`;

        console.log("URL: ", url);

        fetch(url, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        })

            .then((response) => {
                if (response.status != 200) { console.log("response.status", response.status); }
                else return response.json();
            })
            .then(data => {



                const parsedData = JSON.parse(data);

                const patientData = parsedData.Data



                console.log("patientLists of" + CommonAPIConstants.GetAllPatientNames, patientData);

                if (Array.isArray(patientData)) {
                    setSearchPatientData
                        (patientData.map((item) => ({
                            label: `${item.LastName}, ${item.FirstName}`,
                            val: item.PatientID,
                        })));



                    setSelectedCPTPatientID(patientData.val);
                    console.log("Filtered patientLists of" + CommonAPIConstants.GetAllPatientNames, selectedCPTPatientID);

                }


                else {


                    setSearchPatientData([]);


                }
                console.log("PatientsuggestionsLists", searchPatientData);


            })
            .catch((error) => {
                console.error('Error fetching patient names:', error);
            });



    };







    const isMounted = useRef(true);

    useEffect(() => {

        if (isMounted.current) {
            isMounted.current = false;
        } else {
            fetchSuggestionPatientNames(searchPatientText);
        }
    }, [searchPatientText]);





    const handlePatientSuggestion = (suggestion) => {

        setSearchPatientText(`${suggestion.label}`);
        setSelectedSuggestion(suggestion.label);
        setSelectedCPTPatientID(suggestion.val);
        setSearchPatientData([]);
        setShowFaxModal(true);
        setSelectedPatientID(suggestion.val)

        console.log('Selected PatientId suggestion:', selectedPatientID);


    };


    const handleKeyDown = (e) => {
        if (e.key === 'Backspace') {
            // Handle backspace key
            if (searchPatientText === '' && searchPatientData.length > 0) {

                setSearchPatientData([]);


            } else {

                fetchSuggestionPatientNames(searchPatientText.slice(0, -1)) // Remove the last character from searchText

            }
        }
    }


    const fetchProviders = () => {

        var inputStruct = {

            "sProviderName": searchText,
            "sPracticeID": userPracticeID,
            "LoggedInUserDetails": userData

        }

        console.log('userData', userData);
        var myInput = { sInputJSON: JSON.stringify(inputStruct) };

        var myInputData = JSON.stringify(myInput);
        console.log("input of" + IntelliBillConstants.GetIntelliProvidersNames, myInputData);

        const response = fetch(APIConstants.BASE_URL + IntelliBillConstants.GetIntelliProvidersNames, {
            method: 'POST',
            headers: {

                'Accept': 'application/json',
                'Content-Type': 'application/json'

            },

            body: myInputData
        })

            .then((response) => response.json())
            .then((data) => {
                // Extract the relevant data from the response

                const parsedData = JSON.parse(data.d);

                const providersData = parsedData.Data

                console.log("providersLists of " + IntelliBillConstants.GetIntelliProvidersNames, providersData);


                if (Array.isArray(providersData)) {
                    setSuggestions(providersData.map((item) => ({
                        label: (item.split('$')[0]).split('|')[1].trim(),
                        val: item.split('$')[1].trim(),
                    })));
                } else {
                    setSuggestions([]);
                    setIsTextBoxDisabled(false);
                }


            })
            .catch((error) => {
                console.error('Error fetching provider names:', error);

            });



    };





    const fetchSearchProviders = () => {

        if (!selectedProviderData) {
            // If searchText is empty, you may want to reset or clear any existing data
            setSearchPatientData([]);
            setIsSuggestionBoxDisabled(true); // Disable suggestion box if needed
            return; // Skip API call
        }


        for (const rowIndex of providerAllCheckbox) {
            const item = tableDetails[rowIndex];

            item.ProvderName = selectedProviderData;
        }


        var inputStruct = {

            "sProviderName": selectedProviderData,
            "sPracticeID": userPracticeID,
            "LoggedInUserDetails": userData

        }

        console.log('userData', userData);
        var myInput = { sInputJSON: JSON.stringify(inputStruct) };

        var myInputData = JSON.stringify(myInput);
        console.log("input of" + IntelliBillConstants.GetIntelliProvidersNames, myInputData);

        const response = fetch(APIConstants.BASE_URL + IntelliBillConstants.GetIntelliProvidersNames, {
            method: 'POST',
            headers: {

                'Accept': 'application/json',
                'Content-Type': 'application/json'

            },

            body: myInputData
        })

            .then((response) => response.json())
            .then((data) => {
                // Extract the relevant data from the response

                const parsedData = JSON.parse(data.d);

                const providersData = parsedData.Data

                console.log("providersLists of " + IntelliBillConstants.GetIntelliProvidersNames, providersData);


                if (Array.isArray(providersData)) {
                    setSuggestionProviders(providersData.map((item) => ({
                        label: (item.split('$')[0]).split('|')[1].trim(),
                        val: item.split('$')[1].trim(),
                    })));
                } else {
                    setSuggestionProviders([]);
                }



            })
            .catch((error) => {
                console.error('Error fetching provider names:', error);

            });
    };



    useEffect(() => {
        // Fetch suggestions when the component mounts or when searchText changes

        fetchSearchProviders(selectedProviderData);
    }, [selectedProviderData]);



    const handleProviderSuggestion = (suggestion) => {
        setSearchProvidersText(suggestion.label);

        setselectedProviderData(suggestion.label);
        setSearchProvidersText(suggestion.val)
        setSuggestionProviders([]);

        console.log('Selected suggestion:', suggestion);
    };


    const handleProviderKeyDown = (e) => {
        if (e.key === 'Backspace') {
            // Handle backspace key
            if (selectedProviderData === '' && suggestionProviders.length > 0) {
                // If input is empty and there are suggestions, remove the entire list
                setSuggestionProviders([]);


            } else {
                // If input is not empty, dynamically filter suggestions based on the current input
                fetchSearchProviders(selectedProviderData.slice(0, -1)) // Remove the last character from searchText

            }
        }
    }






    const fetchInsuranceCompanies = () => {

        var inputJSON = {

            SearchKey: searchText,

        }

        var sJSONInput = JSON.stringify(inputJSON);
        console.log("input of" + CommonAPIConstants.GetInsuCompanyNames, inputJSON);

        const url = `${APIConstants.BASE_URL_SEARCH}${CommonAPIConstants.GetInsuCompanyNames}?sJSONInput=${sJSONInput}`;

        console.log("URL: ", url);

        fetch(url, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        })

            .then((response) => {
                if (response.status != 200) { console.log("response.status", response.status); }
                else return response.json();
            })
            .then(data => {


                const parsedData = JSON.parse(data);

                const InsuranceData = parsedData.Data

                console.log("InsuranceLists of" + CommonAPIConstants.GetInsuCompanyNames, InsuranceData);




                if (Array.isArray(InsuranceData)) {

                    const filteredSuggestions = InsuranceData

                        .map(item => ({
                            label: item.Insurance,
                            val: item.InsuID,
                        }))
                        .filter(item => item.label !== selectedData && item.label !== '');



                    setSuggestions(filteredSuggestions);

                } else {
                    setSuggestions([]);
                    setIsTextBoxDisabled(false);
                }


                console.log("suggestionsLists", suggestions);
                setIsTextBoxDisabled(false);
            })

            .catch((error) => {
                console.error('Error fetching Insurance names:', error);

            });



    };








    //Fetch CPT List


    const fetchCPTList = () => {

        if (!selectedCptValue) {
            // If searchText is empty, you may want to reset or clear any existing data
            setCptValueList([]);
            setIsSuggestionBoxDisabled(true); // Disable suggestion box if needed
            return; // Skip API call
        }



        for (const rowIndex of cptAllCheckbox) {
            const item = tableDetails[rowIndex];

            item.CPT = selectedCPTCode;
        }



        var inputStruct =
        {
            cptCode: selectedCptValue
        }

        console.log('userData', userData);
        var myInput = { sInputJSON: JSON.stringify(inputStruct) };

        var myInputData = JSON.stringify(myInput);
        console.log("input of" + CommonAPIConstants.GetCPTList, myInputData);


        const response = fetch(APIConstants.BASE_URL + CommonAPIConstants.GetCPTList, {
            method: 'POST',

            headers: {

                'Accept': 'application/json',
                'Content-Type': 'application/json'

            },

            body: myInputData
        })

            .then((response) => response.json())
            .then((data) => {
                // Extract the relevant data from the response

                const parsedData = JSON.parse(data.d);

                const cptData = parsedData.Data

                const filteredCPTData = cptData.filter(item =>
                    `${item.CPT_Code} ${item.CPTDescription}` !== selectedCptValue
                );

                setCptValueList(filteredCPTData);

                console.log("CPTLists of " + CommonAPIConstants.GetCPTList, cptValueList);
            })
            .catch((error) => {
                console.error('Error fetching CPT names:', error);

            });
    };



    useEffect(() => {
        // Fetch suggestions when the component mounts or when searchText changes
        fetchCPTList(selectedCptValue);
    }, [selectedCptValue]);

    const handleCPTList = (suggestion) => {
        setSelectedCptValue(`${suggestion.CPT_Code} ${suggestion.CPTDescription}`);
        setSelectedCPTCode(`${suggestion.CPT_Code}`);
        setCptValueList([]);
        setSelectedUnitValue(1);
        const billingFee = parseFloat(suggestion.Billing_Fee).toFixed(2);
        setSelectedUnitChargeValue(billingFee);

        console.log('Selected suggestion:', billingFee);
    };


    const handleCPTKeyDown = (e) => {
        if (e.key === 'Backspace') {
            // Handle backspace key
            if (selectedCptValue === '' && cptValueList.length > 0) {
                // If input is empty and there are suggestions, remove the entire list
                setCptValueList([]);


            } else {
                // If input is not empty, dynamically filter suggestions based on the current input
                fetchCPTList(selectedCptValue.slice(0, -1)) // Remove the last character from searchText

            }
        }
    }


    // Fetch Mod1 suggestion List



    const fetchMod1List = () => {

        if (!selectedMod1Value) {
            // If searchText is empty, you may want to reset or clear any existing data
            setMod1List([]);
            setIsSuggestionBoxDisabled(true); // Disable suggestion box if needed
            return; // Skip API call
        }


        for (const rowIndex of mod1AllCheckbox) {
            const item = tableDetails[rowIndex];

            item.Mod1 = selectedMod1Data;
        }


        var inputStruct =
        {
            modName: selectedMod1Value
        }

        console.log('userData', userData);
        var myInput = { sInputJSON: JSON.stringify(inputStruct) };

        var myInputData = JSON.stringify(myInput);
        console.log("input of" + CommonAPIConstants.GetModList, myInputData);

        const response = fetch(APIConstants.BASE_URL + CommonAPIConstants.GetModList, {
            method: 'POST',

            headers: {

                'Accept': 'application/json',
                'Content-Type': 'application/json'

            },

            body: myInputData
        })

            .then((response) => response.json())
            .then((data) => {
                // Extract the relevant data from the response

                const parsedData = JSON.parse(data.d);

                const modData = parsedData.Data


                console.log("ModLists of " + CommonAPIConstants.GetModList, modData);


                if (Array.isArray(modData)) {
                    setMod1List(
                        modData.map((item) => {
                            if (item && typeof item === 'object' && 'Value' in item) {
                                return {
                                    val: item.Value.split(' | ')[0],
                                };
                            } else {
                                console.error('Invalid item in modData:', item);
                                return null;
                            }
                        })
                    );
                } else {
                    setMod1List([]);
                }


            })
            .catch((error) => {
                console.error('Error fetching Mod names:', error);

            });
    };



    useEffect(() => {

        fetchMod1List(selectedMod1Value);
    }, [selectedMod1Value]);

    const handleMod1List = (suggestion) => {
        const concatenatedValue = `${suggestion.val}-${suggestion.val}`;

        setSelectedMod1Value(concatenatedValue);
        setSelectedMod1Data(suggestion.val)


        console.log('Selected suggestion:', suggestion);
    };


    const handleMod1ListKeyDown = (e) => {
        if (e.key === 'Backspace') {
            //Handle backspace key
            if (selectedMod1Value === '' && modDataList.length > 0) {
                // If input is empty and there are suggestions, remove the entire list
                setMod1List([]);


            } else {
                // If input is not empty, dynamically filter suggestions based on the current input
                fetchModList(selectedMod1Value.slice(0, -1))//Remove the last character from searchText

            }
        }
    }


    //Fetch Mod2 suggestions List


    const fetchMod2Data = () => {

        if (!selectedMod2ListVal) {
            // If searchText is empty, you may want to reset or clear any existing data
            setMod2List([]);
            setIsSuggestionBoxDisabled(true); // Disable suggestion box if needed
            return; // Skip API call
        }


        for (const rowIndex of mod2AllCheckbox) {
            const item = tableDetails[rowIndex];

            item.Mod2 = selectedMod2Data;
        }


        var inputStruct =
        {
            modName: selectedMod2ListVal
        }

        console.log('userData', userData);
        var myInput = { sInputJSON: JSON.stringify(inputStruct) };

        var myInputData = JSON.stringify(myInput);
        console.log("input of" + CommonAPIConstants.GetModList, myInputData);

        const response = fetch(APIConstants.BASE_URL + CommonAPIConstants.GetModList, {
            method: 'POST',

            headers: {

                'Accept': 'application/json',
                'Content-Type': 'application/json'

            },

            body: myInputData
        })

            .then((response) => response.json())
            .then((data) => {
                // Extract the relevant data from the response

                const parsedData = JSON.parse(data.d);

                const modData = parsedData.Data


                console.log("ModLists of " + CommonAPIConstants.GetModList, modData);


                if (Array.isArray(modData)) {
                    setMod2List(
                        modData.map((item) => {
                            if (item && typeof item === 'object' && 'Value' in item) {
                                return {
                                    val: item.Value.split(' | ')[0],
                                };
                            } else {
                                console.error('Invalid item in modData:', item);
                                return null;
                            }
                        })
                    );
                } else {
                    setMod2List([]);
                }


            })
            .catch((error) => {
                console.error('Error fetching Mod names:', error);

            });
    };



    useEffect(() => {

        fetchMod2Data(selectedMod2ListVal);
    }, [selectedMod2ListVal]);

    const handleMod2Data = (suggestion) => {
        const concatenatedValue = `${suggestion.val}-${suggestion.val}`;

        setSelectedMod2ListVal(concatenatedValue);

        setSelectedMod2Data(suggestion.val)
        console.log('Selected suggestion:', suggestion);
    };


    const handleMod2KeyDown = (e) => {
        if (e.key === 'Backspace') {
            //Handle backspace key
            if (selectedMod2ListVal === '' && mod2List.length > 0) {
                // If input is empty and there are suggestions, remove the entire list
                setMod2List([]);


            } else {
                // If input is not empty, dynamically filter suggestions based on the current input
                fetchMod2Data(selectedMod2ListVal.slice(0, -1))//Remove the last character from searchText

            }
        }
    }



    //Fetch Mod3 Suggestions List


    const fetchMod3Data = () => {

        if (!selectedMod3ListVal) {
            // If searchText is empty, you may want to reset or clear any existing data
            setMod3List([]);
            setIsSuggestionBoxDisabled(true); // Disable suggestion box if needed
            return; // Skip API call
        }


        for (const rowIndex of mod3AllCheckbox) {
            const item = tableDetails[rowIndex];

            item.Mod3 = selectedMod3Data;
        }

        var inputStruct =
        {
            modName: selectedMod3ListVal
        }

        console.log('userData', userData);
        var myInput = { sInputJSON: JSON.stringify(inputStruct) };

        var myInputData = JSON.stringify(myInput);
        console.log("input of" + CommonAPIConstants.GetModList, myInputData);

        const response = fetch(APIConstants.BASE_URL + CommonAPIConstants.GetModList, {
            method: 'POST',

            headers: {

                'Accept': 'application/json',
                'Content-Type': 'application/json'

            },

            body: myInputData
        })

            .then((response) => response.json())
            .then((data) => {
                // Extract the relevant data from the response

                const parsedData = JSON.parse(data.d);

                const modData = parsedData.Data


                console.log("ModLists of " + CommonAPIConstants.GetModList, modData);


                if (Array.isArray(modData)) {
                    setMod3List(
                        modData.map((item) => {
                            if (item && typeof item === 'object' && 'Value' in item) {
                                return {
                                    val: item.Value.split(' | ')[0],
                                };
                            } else {
                                console.error('Invalid item in modData:', item);
                                return null;
                            }
                        })
                    );
                } else {
                    setMod3List([]);
                }


            })
            .catch((error) => {
                console.error('Error fetching Mod names:', error);

            });
    };



    useEffect(() => {

        fetchMod3Data(selectedMod3ListVal);
    }, [selectedMod3ListVal]);

    const handleMod3Data = (suggestion) => {
        const concatenatedValue = `${suggestion.val}-${suggestion.val}`;

        setSelectedMod3ListVal(concatenatedValue);

        setSelectedMod3Data(suggestion.val)
        console.log('Selected suggestion:', suggestion);
    };


    const handleMod3KeyDown = (e) => {
        if (e.key === 'Backspace') {
            //Handle backspace key
            if (selectedMod3ListVal === '' && mod3List.length > 0) {
                // If input is empty and there are suggestions, remove the entire list
                setMod3List([]);


            } else {
                // If input is not empty, dynamically filter suggestions based on the current input
                fetchMod3Data(selectedMod3ListVal.slice(0, -1))//Remove the last character from searchText

            }
        }
    }


    // Fetch ICD1 Suggestion List


    const fetchDiag1DataList = () => {

        if (!selectedDiag1List) {

            setDiag1List([]);
            setIsSuggestionBoxDisabled(true);
            return;
        }




        for (const rowIndex of diag1AllCheckbox) {
            const item = tableDetails[rowIndex];

            item.ICDCode = selectedDiag1ID;
        }


        var inputStruct =
        {
            icdName: selectedDiag1List
        }

        console.log('userData', userData);
        var myInput = { sInputJSON: JSON.stringify(inputStruct) };

        var myInputData = JSON.stringify(myInput);
        console.log("input of" + CommonAPIConstants.GetIcdList, myInputData);

        const response = fetch(APIConstants.BASE_URL + CommonAPIConstants.GetIcdList, {
            method: 'POST',

            headers: {

                'Accept': 'application/json',
                'Content-Type': 'application/json'

            },

            body: myInputData
        })

            .then((response) => response.json())
            .then((data) => {
                // Extract the relevant data from the response

                const parsedData = JSON.parse(data.d);

                const diagData = parsedData.Data


                console.log("ICDLists of " + CommonAPIConstants.GetIcdList, diagData);

                setDiag1List(diagData)


            })
            .catch((error) => {
                console.error('Error fetching ICD names:', error);

            });
    };



    useEffect(() => {

        fetchDiag1DataList(selectedDiag1List);
    }, [selectedDiag1List]);

    const handleDiag1DataList = (suggestion) => {
        setSelectedDiag1List(suggestion.Value);
        const diagID = suggestion.Value.split(' ')[0].trim();

        setSelectedDiag1ID(diagID)
        console.log('Selected suggestion diagID:', selectedDiag1ID);
    };


    const handleDiag1DataKeyDown = (e) => {
        if (e.key === 'Backspace') {
            //Handle backspace key
            if (selectedDiag1List === '' && diag1List.length > 0) {
                // If input is empty and there are suggestions, remove the entire list
                setDiag1List([]);


            } else {
                // If input is not empty, dynamically filter suggestions based on the current input
                fetchDiag1DataList(selectedDiag1List.slice(0, -1))//Remove the last character from searchText

            }
        }
    }




    //Fetch ICD2 Suggestion List

    const fetchDiag2DataList = () => {

        if (!selectedDiag2List) {

            setDiag2List([]);
            setIsSuggestionBoxDisabled(true);
            return;
        }


        for (const rowIndex of diag2AllCheckbox) {
            const item = tableDetails[rowIndex];

            item.ICDCode2 = selectedDiag1ID;
        }



        var inputStruct =
        {
            icdName: selectedDiag2List
        }

        console.log('userData', userData);
        var myInput = { sInputJSON: JSON.stringify(inputStruct) };

        var myInputData = JSON.stringify(myInput);
        console.log("input of" + CommonAPIConstants.GetIcdList, myInputData);

        const response = fetch(APIConstants.BASE_URL + CommonAPIConstants.GetIcdList, {
            method: 'POST',

            headers: {

                'Accept': 'application/json',
                'Content-Type': 'application/json'

            },

            body: myInputData
        })

            .then((response) => response.json())
            .then((data) => {
                // Extract the relevant data from the response

                const parsedData = JSON.parse(data.d);

                const diagData = parsedData.Data


                console.log("ICDLists of " + CommonAPIConstants.GetIcdList, diagData);

                setDiag2List(diagData)


            })
            .catch((error) => {
                console.error('Error fetching ICD names:', error);

            });
    };



    useEffect(() => {

        fetchDiag2DataList(selectedDiag2List);
    }, [selectedDiag2List]);

    const handleDiag2DataList = (suggestion) => {
        setSelectedDiag2List(suggestion.Value);
        const diagID = suggestion.Value.split(' ')[0].trim();

        setSelectedDiag1ID(diagID)
        console.log('Selected suggestion diagID:', selectedDiag1ID);
    };


    const handleDiag2DataKeyDown = (e) => {
        if (e.key === 'Backspace') {
            //Handle backspace key
            if (selectedDiag2List === '' && diag2List.length > 0) {
                // If input is empty and there are suggestions, remove the entire list
                setDiag2List([]);


            } else {
                // If input is not empty, dynamically filter suggestions based on the current input
                fetchDiag2DataList(selectedDiag2List.slice(0, -1))//Remove the last character from searchText

            }
        }
    }


    //Fetch ICD3 Suggestion List


    const fetchDiag3DataList = () => {

        if (!selectedDiag3List) {

            setDiag3List([]);
            setIsSuggestionBoxDisabled(true);
            return;
        }


        for (const rowIndex of diag3AllCheckbox) {
            const item = tableDetails[rowIndex];

            item.ICDCode3 = selectedDiag1ID;
        }


        var inputStruct =
        {
            icdName: selectedDiag3List
        }

        console.log('userData', userData);
        var myInput = { sInputJSON: JSON.stringify(inputStruct) };

        var myInputData = JSON.stringify(myInput);
        console.log("input of" + CommonAPIConstants.GetIcdList, myInputData);

        const response = fetch(APIConstants.BASE_URL + CommonAPIConstants.GetIcdList, {
            method: 'POST',

            headers: {

                'Accept': 'application/json',
                'Content-Type': 'application/json'

            },

            body: myInputData
        })

            .then((response) => response.json())
            .then((data) => {
                // Extract the relevant data from the response

                const parsedData = JSON.parse(data.d);

                const diagData = parsedData.Data


                console.log("ICDLists of " + CommonAPIConstants.GetIcdList, diagData);

                setDiag3List(diagData)


            })
            .catch((error) => {
                console.error('Error fetching ICD names:', error);

            });
    };



    useEffect(() => {

        fetchDiag3DataList(selectedDiag3List);
    }, [selectedDiag3List]);

    const handleDiag3DataList = (suggestion) => {
        setSelectedDiag3List(suggestion.Value);
        const diagID = suggestion.Value.split(' ')[0].trim();

        setSelectedDiag1ID(diagID)
        console.log('Selected suggestion diagID:', selectedDiag1ID);
    };


    const handleDiag3DataKeyDown = (e) => {
        if (e.key === 'Backspace') {
            //Handle backspace key
            if (selectedDiag3List === '' && diag3List.length > 0) {
                // If input is empty and there are suggestions, remove the entire list
                setDiag3List([]);


            } else {
                // If input is not empty, dynamically filter suggestions based on the current input
                fetchDiag3DataList(selectedDiag3List.slice(0, -1))//Remove the last character from searchText

            }
        }
    }



    //Fetch ICD4 Suggestion List


    const fetchDiag4DataList = () => {

        if (!selectedDiag4List) {

            setDiag4List([]);
            setIsSuggestionBoxDisabled(true);
            return;
        }


        for (const rowIndex of diag4AllCheckbox) {
            const item = tableDetails[rowIndex];

            item.ICDCode4 = selectedDiag1ID;
        }



        var inputStruct =
        {
            icdName: selectedDiag4List
        }

        console.log('userData', userData);
        var myInput = { sInputJSON: JSON.stringify(inputStruct) };

        var myInputData = JSON.stringify(myInput);
        console.log("input of" + CommonAPIConstants.GetIcdList, myInputData);

        const response = fetch(APIConstants.BASE_URL + CommonAPIConstants.GetIcdList, {
            method: 'POST',

            headers: {

                'Accept': 'application/json',
                'Content-Type': 'application/json'

            },

            body: myInputData
        })

            .then((response) => response.json())
            .then((data) => {
                // Extract the relevant data from the response

                const parsedData = JSON.parse(data.d);

                const diagData = parsedData.Data


                console.log("ICDLists of " + CommonAPIConstants.GetIcdList, diagData);

                setDiag4List(diagData)


            })
            .catch((error) => {
                console.error('Error fetching ICD names:', error);

            });
    };



    useEffect(() => {

        fetchDiag4DataList(selectedDiag4List);
    }, [selectedDiag4List]);

    const handleDiag4DataList = (suggestion) => {
        setSelectedDiag4List(suggestion.Value);
        const diagID = suggestion.Value.split(' ')[0].trim();

        setSelectedDiag1ID(diagID)
        console.log('Selected suggestion diagID:', selectedDiag1ID);
    };


    const handleDiag4DataKeyDown = (e) => {
        if (e.key === 'Backspace') {
            //Handle backspace key
            if (selectedDiag4List === '' && diag4List.length > 0) {
                // If input is empty and there are suggestions, remove the entire list
                setDiag4List([]);


            } else {
                // If input is not empty, dynamically filter suggestions based on the current input
                fetchDiag4DataList(selectedDiag4List.slice(0, -1))//Remove the last character from searchText

            }
        }
    }




    // Fetch Providers List for Dialogbox


    const fetchSearchProvidersList = () => {

        if (!selectedProviderText) {
            setProviderDataList([]);
            setIsSuggestionBoxDisabled(true);
            return;
        }

        var inputStruct = {

            "sProviderName": selectedProviderText,
            "sPracticeID": userPracticeID,
            "LoggedInUserDetails": userData

        }

        console.log('userData', userData);
        var myInput = { sInputJSON: JSON.stringify(inputStruct) };

        var myInputData = JSON.stringify(myInput);
        console.log("input of" + IntelliBillConstants.GetIntelliProvidersNames, myInputData);

        const response = fetch(APIConstants.BASE_URL + IntelliBillConstants.GetIntelliProvidersNames, {
            method: 'POST',
            headers: {

                'Accept': 'application/json',
                'Content-Type': 'application/json'

            },

            body: myInputData
        })

            .then((response) => response.json())
            .then((data) => {
                // Extract the relevant data from the response

                const parsedData = JSON.parse(data.d);

                const providersData = parsedData.Data

                console.log("providersLists of " + IntelliBillConstants.GetIntelliProvidersNames, providersData);


                if (Array.isArray(providersData)) {
                    // Correct the structure of filteredProviders
                    const filteredProviders = providersData
                        .filter(item => item.toLowerCase().includes(selectedProviderText.toLowerCase()))
                        .map((item) => ({
                            label: (item.split('$')[0]).split('|')[1].trim(),
                            id: item.split('$')[1].trim(),
                        }))
                        .filter(item => item.label !== selectedProviderSuggestion.label);

                    setProviderDataList(filteredProviders);
                } else {
                    setProviderDataList([]);
                }
            })
            .catch((error) => {
                console.error('Error fetching provider names:', error);
            });
    };


    const isProviderMounted = useRef(true);

    useEffect(() => {

        if (isProviderMounted.current) {
            isProviderMounted.current = false;
        } else {
            fetchSearchProvidersList(selectedProviderText);
        }
    }, [selectedProviderText]);




    const handleProviderSuggestionList = (suggestion) => {
        setSelectedProviderText(`${suggestion.label}`);
        setSelectedProviderSuggestion(`${suggestion.id}`);
        setProviderDataList([]);
        setSelectedPatientID(selectedPatientID)

        console.log('Selected suggestion:', selectedProviderSuggestion);

    };


    const handleProviderListKeyDown = (e) => {
        if (e.key === 'Backspace') {
            // Handle backspace key
            if (selectedProviderText === '' && providerDataList.length > 0) {
                // If input is empty and there are suggestions, remove the entire list
                setProviderDataList([]);


            } else {
                // If input is not empty, dynamically filter suggestions based on the current input
                fetchSearchProvidersList(selectedProviderText.slice(0, -1)) // Remove the last character from searchText

            }
        }
    }




    //Fetch CPT List

    const fetchSearchCPTList = () => {

        if (!selectedCPTList) {
            // If searchText is empty, you may want to reset or clear any existing data
            setCptDataList([]);
            setIsSuggestionBoxDisabled(true); // Disable suggestion box if needed
            return; // Skip API call
        }



        var inputStruct =
        {
            cptCode: selectedCPTList
        }

        console.log('userData', userData);
        var myInput = { sInputJSON: JSON.stringify(inputStruct) };

        var myInputData = JSON.stringify(myInput);
        console.log("input of" + CommonAPIConstants.GetCPTList, myInputData);


        const response = fetch(APIConstants.BASE_URL + CommonAPIConstants.GetCPTList, {
            method: 'POST',

            headers: {

                'Accept': 'application/json',
                'Content-Type': 'application/json'

            },

            body: myInputData
        })

            .then((response) => response.json())
            .then((data) => {
                // Extract the relevant data from the response

                const parsedData = JSON.parse(data.d);

                const cptData = parsedData.Data

                const filteredCPTData = cptData.filter(item =>
                    `${item.CPT_Code} ${item.CPTDescription}` !== selectedCPTList
                );

                setCptDataList(filteredCPTData);

                console.log("CPTLists of " + CommonAPIConstants.GetCPTList, cptDataList);
            })
            .catch((error) => {
                console.error('Error fetching CPT names:', error);

            });
    };



    useEffect(() => {
        // Fetch suggestions when the component mounts or when searchText changes
        fetchSearchCPTList(selectedCPTList);
    }, [selectedCPTList]);

    const handleSearchCPTList = (suggestion) => {
        setSelectedCPTList(`${suggestion.CPT_Code} ${suggestion.CPTDescription}`);
        setSelectedCPTCode(`${suggestion.CPT_Code}`);
        setCptDataList([]);
        setSelectedUnitValue(1);
        const billingFee = parseFloat(suggestion.Billing_Fee).toFixed(2);
        setSelectedUnitChargeValue(billingFee);

        console.log('Selected suggestion:', billingFee);
    };


    const handleCPTListKeyDown = (e) => {
        if (e.key === 'Backspace') {
            // Handle backspace key
            if (selectedCPTList === '' && cptDataList.length > 0) {
                // If input is empty and there are suggestions, remove the entire list
                setCptDataList([]);


            } else {
                // If input is not empty, dynamically filter suggestions based on the current input
                fetchSearchCPTList(selectedCPTList.slice(0, -1)) // Remove the last character from searchText

            }
        }
    }

    //Fetch Mod1 List

    const fetchModList = () => {

        if (!selectedModList) {
            // If searchText is empty, you may want to reset or clear any existing data
            setModDataList([]);
            setIsSuggestionBoxDisabled(true); // Disable suggestion box if needed
            return; // Skip API call
        }



        var inputStruct =
        {
            modName: selectedModList
        }

        console.log('userData', userData);
        var myInput = { sInputJSON: JSON.stringify(inputStruct) };

        var myInputData = JSON.stringify(myInput);
        console.log("input of" + CommonAPIConstants.GetModList, myInputData);

        const response = fetch(APIConstants.BASE_URL + CommonAPIConstants.GetModList, {
            method: 'POST',

            headers: {

                'Accept': 'application/json',
                'Content-Type': 'application/json'

            },

            body: myInputData
        })

            .then((response) => response.json())
            .then((data) => {
                // Extract the relevant data from the response

                const parsedData = JSON.parse(data.d);

                const modData = parsedData.Data


                console.log("ModLists of " + CommonAPIConstants.GetModList, modData);


                if (Array.isArray(modData)) {
                    setModDataList(
                        modData.map((item) => {
                            if (item && typeof item === 'object' && 'Value' in item) {
                                return {
                                    val: item.Value.split(' | ')[0],
                                };
                            } else {
                                console.error('Invalid item in modData:', item);
                                return null;
                            }
                        })
                    );
                } else {
                    setModDataList([]);
                }


            })
            .catch((error) => {
                console.error('Error fetching Mod names:', error);

            });
    };



    useEffect(() => {

        fetchModList(selectedModList);
    }, [selectedModList]);

    const handleModList = (suggestion) => {
        setSelectedModList(suggestion);


        console.log('Selected suggestion:', suggestion);
    };


    const handleModListKeyDown = (e) => {
        if (e.key === 'Backspace') {
            //Handle backspace key
            if (selectedModList === '' && modDataList.length > 0) {
                // If input is empty and there are suggestions, remove the entire list
                setModDataList([]);


            } else {
                // If input is not empty, dynamically filter suggestions based on the current input
                fetchModList(selectedModList.slice(0, -1))//Remove the last character from searchText

            }
        }
    }


    //Fetch Mod2 SuggestionList



    const fetchMod2List = () => {

        if (!selectedMod2Value) {
            // If searchText is empty, you may want to reset or clear any existing data
            setMod2DataList([]);
            setIsSuggestionBoxDisabled(true); // Disable suggestion box if needed
            return; // Skip API call
        }



        var inputStruct =
        {
            modName: selectedMod2Value
        }

        console.log('userData', userData);
        var myInput = { sInputJSON: JSON.stringify(inputStruct) };

        var myInputData = JSON.stringify(myInput);
        console.log("input of" + CommonAPIConstants.GetModList, myInputData);

        const response = fetch(APIConstants.BASE_URL + CommonAPIConstants.GetModList, {
            method: 'POST',

            headers: {

                'Accept': 'application/json',
                'Content-Type': 'application/json'

            },

            body: myInputData
        })

            .then((response) => response.json())
            .then((data) => {
                // Extract the relevant data from the response

                const parsedData = JSON.parse(data.d);

                const modData = parsedData.Data


                console.log("ModLists of " + CommonAPIConstants.GetModList, modData);


                if (Array.isArray(modData)) {
                    setMod2DataList(
                        modData.map((item) => {
                            if (item && typeof item === 'object' && 'Value' in item) {
                                return {
                                    val: item.Value.split(' | ')[0],
                                };
                            } else {
                                console.error('Invalid item in modData:', item);
                                return null;
                            }
                        })
                    );
                } else {
                    setMod2DataList([]);
                }


            })
            .catch((error) => {
                console.error('Error fetching Mod names:', error);

            });
    };



    useEffect(() => {

        fetchMod2List(selectedMod2Value);
    }, [selectedMod2Value]);

    const handleMod2List = (suggestion) => {
        setSelectedMod2Value(suggestion);
        //setMod2DataList([]);

        console.log('Selected suggestion:', suggestion);
    };


    const handleMod2ListKeyDown = (e) => {
        if (e.key === 'Backspace') {
            //Handle backspace key
            if (selectedMod2Value === '' && mod2DataList.length > 0) {
                // If input is empty and there are suggestions, remove the entire list
                setMod2DataList([]);


            } else {
                // If input is not empty, dynamically filter suggestions based on the current input
                fetchMod2List(selectedMod2Value.slice(0, -1))//Remove the last character from searchText

            }
        }
    }


    //Fetch Mod3 SuggestionList

    const fetchMod3List = () => {

        if (!selectedMod3Value) {
            // If searchText is empty, you may want to reset or clear any existing data
            setMod3DataList([]);
            setIsSuggestionBoxDisabled(true); // Disable suggestion box if needed
            return; // Skip API call
        }



        var inputStruct =
        {
            modName: selectedMod3Value
        }

        console.log('userData', userData);
        var myInput = { sInputJSON: JSON.stringify(inputStruct) };

        var myInputData = JSON.stringify(myInput);
        console.log("input of" + CommonAPIConstants.GetModList, myInputData);

        const response = fetch(APIConstants.BASE_URL + CommonAPIConstants.GetModList, {
            method: 'POST',

            headers: {

                'Accept': 'application/json',
                'Content-Type': 'application/json'

            },

            body: myInputData
        })

            .then((response) => response.json())
            .then((data) => {
                // Extract the relevant data from the response

                const parsedData = JSON.parse(data.d);

                const modData = parsedData.Data


                console.log("ModLists of " + CommonAPIConstants.GetModList, modData);


                if (Array.isArray(modData)) {
                    setMod3DataList(
                        modData.map((item) => {
                            if (item && typeof item === 'object' && 'Value' in item) {
                                return {
                                    val: item.Value.split(' | ')[0],
                                };
                            } else {
                                console.error('Invalid item in modData:', item);
                                return null;
                            }
                        })
                    );
                } else {
                    setMod3DataList([]);
                }


            })
            .catch((error) => {
                console.error('Error fetching Mod names:', error);

            });
    };



    useEffect(() => {

        fetchMod3List(selectedMod3Value);
    }, [selectedMod3Value]);

    const handleMod3List = (suggestion) => {
        setSelectedMod3Value(suggestion);
        // setMod3DataList([]);

        console.log('Selected suggestion:', suggestion);
    };


    const handleMod3ListKeyDown = (e) => {
        if (e.key === 'Backspace') {
            //Handle backspace key
            if (selectedMod3Value === '' && mod3DataList.length > 0) {
                // If input is empty and there are suggestions, remove the entire list
                setMod3DataList([]);


            } else {
                // If input is not empty, dynamically filter suggestions based on the current input
                fetchMod3List(selectedMod3Value.slice(0, -1))//Remove the last character from searchText

            }
        }
    }



    //Fetch ICD1 Suggestion List                                                         

    const fetchDiag1List = () => {

        if (!selectedDiag1Value) {

            setDiag1DataList([]);
            setIsSuggestionBoxDisabled(true);
            return;
        }



        var inputStruct =
        {
            icdName: selectedDiag1Value
        }

        console.log('userData', userData);
        var myInput = { sInputJSON: JSON.stringify(inputStruct) };

        var myInputData = JSON.stringify(myInput);
        console.log("input of" + CommonAPIConstants.GetIcdList, myInputData);

        const response = fetch(APIConstants.BASE_URL + CommonAPIConstants.GetIcdList, {
            method: 'POST',

            headers: {

                'Accept': 'application/json',
                'Content-Type': 'application/json'

            },

            body: myInputData
        })

            .then((response) => response.json())
            .then((data) => {
                // Extract the relevant data from the response

                const parsedData = JSON.parse(data.d);

                const diagData = parsedData.Data


                console.log("ICDLists of " + CommonAPIConstants.GetIcdList, diagData);

                setDiag1DataList(diagData)


            })
            .catch((error) => {
                console.error('Error fetching ICD names:', error);

            });
    };



    useEffect(() => {

        fetchDiag1List(selectedDiag1Value);
    }, [selectedDiag1Value]);

    const handleDiag1List = (suggestion) => {
        setSelectedDiag1Value(suggestion.Value);
        const diagID = suggestion.Value.split(' ')[0].trim();

        setSelectedDiag1ID(diagID)
        console.log('Selected suggestion diagID:', selectedDiag1ID);
    };


    const handleDiag1ListKeyDown = (e) => {
        if (e.key === 'Backspace') {
            //Handle backspace key
            if (selectedDiag1Value === '' && diag1DataList.length > 0) {
                // If input is empty and there are suggestions, remove the entire list
                setDiag1DataList([]);


            } else {
                // If input is not empty, dynamically filter suggestions based on the current input
                fetchDiag1List(selectedDiag1Value.slice(0, -1))//Remove the last character from searchText

            }
        }
    }







    //Fetch ICD2 Suggestion List

    const fetchDiag2List = () => {

        if (!selectedDiag2Value) {

            setDiag2DataList([]);
            setIsSuggestionBoxDisabled(true);
            return;
        }



        var inputStruct =
        {
            icdName: selectedDiag2Value
        }

        console.log('userData', userData);
        var myInput = { sInputJSON: JSON.stringify(inputStruct) };

        var myInputData = JSON.stringify(myInput);
        console.log("input of" + CommonAPIConstants.GetIcdList, myInputData);

        const response = fetch(APIConstants.BASE_URL + CommonAPIConstants.GetIcdList, {
            method: 'POST',

            headers: {

                'Accept': 'application/json',
                'Content-Type': 'application/json'

            },

            body: myInputData
        })

            .then((response) => response.json())
            .then((data) => {
                // Extract the relevant data from the response

                const parsedData = JSON.parse(data.d);

                const modData = parsedData.Data


                console.log("ICDLists of " + CommonAPIConstants.GetIcdList, modData);

                setDiag2DataList(modData)


            })
            .catch((error) => {
                console.error('Error fetching ICD names:', error);

            });
    };



    useEffect(() => {

        fetchDiag2List(selectedDiag2Value);
    }, [selectedDiag2Value]);

    const handleDiag2List = (suggestion) => {
        setSelectedDiag2Value(suggestion.Value);
        const diagID = suggestion.Value.split(' ')[0].trim();

        setSelectedDiag2ID(diagID)
        console.log('Selected suggestion diagID:', selectedDiag2ID);
    };


    const handleDiag2ListKeyDown = (e) => {
        if (e.key === 'Backspace') {
            //Handle backspace key
            if (selectedDiag2Value === '' && diag2DataList.length > 0) {
                // If input is empty and there are suggestions, remove the entire list
                setDiag2DataList([]);


            } else {
                // If input is not empty, dynamically filter suggestions based on the current input
                fetchDiag2List(selectedDiag2Value.slice(0, -1))//Remove the last character from searchText

            }
        }
    }


    //Fetch ICD3 Suggestion List
    const fetchDiag3List = () => {

        if (!selectedDiag3Value) {

            setDiag3DataList([]);
            setIsSuggestionBoxDisabled(true);
            return;
        }



        var inputStruct =
        {
            icdName: selectedDiag3Value
        }

        console.log('userData', userData);
        var myInput = { sInputJSON: JSON.stringify(inputStruct) };

        var myInputData = JSON.stringify(myInput);
        console.log("input of" + CommonAPIConstants.GetIcdList, myInputData);

        const response = fetch(APIConstants.BASE_URL + CommonAPIConstants.GetIcdList, {
            method: 'POST',

            headers: {

                'Accept': 'application/json',
                'Content-Type': 'application/json'

            },

            body: myInputData
        })

            .then((response) => response.json())
            .then((data) => {
                // Extract the relevant data from the response

                const parsedData = JSON.parse(data.d);

                const modData = parsedData.Data


                console.log("ICDLists of " + CommonAPIConstants.GetIcdList, modData);

                setDiag3DataList(modData)


            })
            .catch((error) => {
                console.error('Error fetching ICD names:', error);

            });
    };



    useEffect(() => {

        fetchDiag3List(selectedDiag3Value);
    }, [selectedDiag3Value]);

    const handleDiag3List = (suggestion) => {
        setSelectedDiag3Value(suggestion.Value);
        const diagID = suggestion.Value.split(' ')[0].trim();

        setSelectedDiag3ID(diagID)
        console.log('Selected suggestion diagID:', selectedDiag3ID);
    };


    const handleDiag3ListKeyDown = (e) => {
        if (e.key === 'Backspace') {
            //Handle backspace key
            if (selectedDiag3Value === '' && diag3DataList.length > 0) {
                // If input is empty and there are suggestions, remove the entire list
                setDiag3DataList([]);


            } else {
                // If input is not empty, dynamically filter suggestions based on the current input
                fetchDiag3List(selectedDiag3Value.slice(0, -1))//Remove the last character from searchText

            }
        }
    }


    //Fetch ICD4 Suggestion List

    const fetchDiag4List = () => {

        if (!selectedDiag4Value) {

            setDiag4DataList([]);
            setIsSuggestionBoxDisabled(true);
            return;
        }



        var inputStruct =
        {
            icdName: selectedDiag4Value
        }

        console.log('userData', userData);
        var myInput = { sInputJSON: JSON.stringify(inputStruct) };

        var myInputData = JSON.stringify(myInput);
        console.log("input of" + CommonAPIConstants.GetIcdList, myInputData);

        const response = fetch(APIConstants.BASE_URL + CommonAPIConstants.GetIcdList, {
            method: 'POST',

            headers: {

                'Accept': 'application/json',
                'Content-Type': 'application/json'

            },

            body: myInputData
        })

            .then((response) => response.json())
            .then((data) => {
                // Extract the relevant data from the response

                const parsedData = JSON.parse(data.d);

                const modData = parsedData.Data


                console.log("ICDLists of " + CommonAPIConstants.GetIcdList, modData);

                setDiag4DataList(modData)


            })
            .catch((error) => {
                console.error('Error fetching ICD names:', error);

            });
    };



    useEffect(() => {

        fetchDiag4List(selectedDiag4Value);
    }, [selectedDiag4Value]);

    const handleDiag4List = (suggestion) => {
        setSelectedDiag4Value(suggestion.Value);
        const diagID = suggestion.Value.split(' ')[0].trim();

        setSelectedDiag4ID(diagID)
        console.log('Selected suggestion diagID:', selectedDiag4ID);
    };


    const handleDiag4ListKeyDown = (e) => {
        if (e.key === 'Backspace') {
            //Handle backspace key
            if (selectedDiag4Value === '' && diag4DataList.length > 0) {
                // If input is empty and there are suggestions, remove the entire list
                setDiag4DataList([]);


            } else {
                // If input is not empty, dynamically filter suggestions based on the current input
                fetchDiag4List(selectedDiag4Value.slice(0, -1))//Remove the last character from searchText

            }
        }
    }




    const handleSelectBillingNPI = (event) => {
        const selectedValue = event.target.value;
        setSelectedBillingNPI(selectedValue);

    }



    const filteredProviders = practiceProvider?.filter(
        (provider) => provider.Supervisor === "1" || provider.Supervisor === "3",
    );


    const handleSelectFilterProviders = (event) => {
        const selectedValue = event.target.value;
        setSelectedFilterProvider(selectedValue);

    }


    const filteredCounselor = practiceProvider?.filter(provider => provider.RoleID == 9);

    const handleSelectFilterCounselor = (event) => {
        const selectedValue = event.target.value;
        setSelectedFilterCounselor(selectedValue);

    }

    const [selectedProvider, setSelectedProvider] = useState('');
    const [tdata, setTdata] = useState('');





    // Function to handle checkbox change
    const handleCheckboxChange = (e) => {
        const value = e.target.checked ? 1 : 0; // Set 1 if checked, 0 if unchecked
        setIsChecked(value);
    };




    useEffect(() => {

        setSelectedCheckedRadioButton('0');
        setSelectedStatusRadioButton('0');
    }, []);

    const handleRadioChange = (e) => {
        setSelectedCheckedRadioButton(e.target.value);
        const selectedValue = e.target.value;
        setsCheckedInStatus(selectedValue);

        console.log("sCheckedInStatus", sCheckedInStatus);
    };



    useEffect(() => {

        console.log('Selected radio button value:', selectedCheckedRadioButton);

        handleTableDataClick();

    }, [selectedCheckedRadioButton]);


    const handleClaimStatusChange = (e) => {

        setSelectedStatusRadioButton(e.target.value);
        const selectedValue = e.target.value;
        setsClaimStatus(selectedValue);

        console.log("claim", sClaimStatus);
    }


    useEffect(() => {

        console.log('Selected radio button value:', selectedStatusRadioButton);
        handleTableDataClick();
    }, [selectedStatusRadioButton]);


    const handleSuggestionChange = (e) => {

        setSelectedSearchFilter(e.target.value);
        const selectedValue = e.target.value;
        setsFilterType(selectedValue);

        console.log("sFilterType", sFilterType);
    }



    const processTableData = () => {
        tableDetails.forEach((item) => {

            setRowsValidation(item.DataValidationMessage);
        });
    };


    //All clearingHouse Data


    const handleAllClearingHouse = () => {





        var inputStruct = {


            "sPracticeID": userPracticeID,

        }

        console.log('LoginuserData', userData);
        var myInput = { sInputJSON: JSON.stringify(inputStruct) };

        var myInputData = JSON.stringify(myInput);
        console.log("input of" + CommonAPIConstants.GetAllclearingHouse, myInputData);

        const response = fetch(APIConstants.BASE_URL + CommonAPIConstants.GetAllclearingHouse, {
            method: 'POST',
            headers: {

                'Accept': 'application/json',
                'Content-Type': 'application/json'

            },

            body: myInputData
        })

            .then((response) => response.json())
            .then((data) => {
                // Extract the relevant data from the response


                const parsedData = JSON.parse(data.d);

                const allClearingHouseData = parsedData.Data

                setSelectClearingHouse(allClearingHouseData);

                console.log("All clearing house" + CommonAPIConstants.GetAllclearingHouse, selectClearinghouse);



            })
            .catch((error) => {
                console.error('Error fetching All clearing house:', error);
            });
    };




    useEffect(() => {

        handleAllClearingHouse();

    }, []);



    //Bind the Intelli Bill table provider



    const handleTableDataClick = (DataValidationMessage) => {
        setLoading(true);

        setSelectedRows([])



        var objInput = {



            iPracticeID: userPracticeID,
            sFromDate: startDate,
            sToDate: endDate,
            sFilterType: 1 + "",
            sInsorPatFilter: selectedSearchFilter,
            sFilterText: sFilterText,
            iProviderFilter: selectedProviderRadio,
            sLocationID: searchByLoaction,
            LoggedInUserDetails: {

                DefaultTimeZoneOffSet: 300,
                roleID: 7,
                dtCurrentWorkingDate: fromDate
            }

        }

        var inputJSON = JSON.stringify(objInput);
        console.log("input of" + SuperBillConstants.GetSuperBillData, inputJSON);
        const url = `${APIConstants.BASE_URL_BILLING}${SuperBillConstants.GetSuperBillData}?sInputJSON=${inputJSON}`;

        console.log("URL: ", url);

        fetch(url, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sAuthToken}`
            }
        })

            .then((response) => {
                if (response.status != 200) { console.log("response.status", response.status); }
                else return response.json();
            })
            .then(data => {


                const parsedTableData = JSON.parse(data);

                setTableDetails(parsedTableData);
                console.log("TableData?????????", parsedTableData);
                
                setTimeout(() => {
                    setLoading(false);
                    setFilteredTableDetails(parsedTableData);
                }, 100);



            })

            .catch((error) => {
                setError('API request failed');
                setLoading(false);
            })




    }













    useEffect(() => {

        return () => setSelectedRows([]);
    }, []);





    const handleRowCheckboxChange = (index) => {
        if (selectedRows.includes(index)) {
            setSelectedRows(selectedRows.filter((selectedRow) => selectedRow !== index));
        } else {
            setSelectedRows([...selectedRows, index]);
        }
    };

    const handleSelectAllChange = () => {
        const allSelected = tableDetails.every((_, index) => selectedRows.includes(index));

        if (allSelected) {
            // Deselect all checkboxes
            setSelectedRows([]);
        } else {
            // Select all checkboxes
            setSelectedRows(Array.from({ length: tableDetails.length }, (_, index) => index));
        }
    };






    useEffect(() => {
        // updateValueField();
    }, [selectedLocationRows, selectedValueLocRows, selectedServiceLocation]);








    const handleSelectCounselorAllChange = () => {
        const allSelected = tableDetails.every((_, index) => counselorAllCheckbox.includes(index));

        if (allSelected) {
            // Deselect all checkboxes
            setcounselorAllCheckbox([]);

        } else {
            // Select all checkboxes
            setcounselorAllCheckbox(Array.from({ length: tableDetails.length }, (_, index) => index));




            console.log("selectedAllrows", counselorAllCheckbox);
        }
    };


    const handleCounselorRowCheckboxChange = (index) => {
        if (counselorAllCheckbox.includes(index)) {
            setcounselorAllCheckbox(counselorAllCheckbox.filter((selectedRow) => selectedRow !== index));



        } else {
            setcounselorAllCheckbox([...counselorAllCheckbox, index]);


        }
    };








    const handleSelectCouCPTAllChange = () => {
        const allSelected = tableDetails.every((_, index) => couCPTAllCheckbox.includes(index));

        if (allSelected) {
            // Deselect all checkboxes
            setcouCPTAllCheckbox([]);

        } else {
            // Select all checkboxes
            setcouCPTAllCheckbox(Array.from({ length: tableDetails.length }, (_, index) => index));




            console.log("selectedAllrows", couCPTAllCheckbox);
        }
    };


    const handleCouCPTRowCheckboxChange = (index) => {
        if (couCPTAllCheckbox.includes(index)) {
            setcouCPTAllCheckbox(couCPTAllCheckbox.filter((selectedRow) => selectedRow !== index));



        } else {
            setcouCPTAllCheckbox([...couCPTAllCheckbox, index]);


        }
    };









    const handleSelectLabCPTAllChange = () => {
        const allSelected = tableDetails.every((_, index) => labCPTAllCheckbox.includes(index));

        if (allSelected) {
            // Deselect all checkboxes
            setlabCPTAllCheckbox([]);

        } else {
            // Select all checkboxes
            setlabCPTAllCheckbox(Array.from({ length: tableDetails.length }, (_, index) => index));




            console.log("selectedAllrows", labCPTAllCheckbox);
        }
    };




    const handleLabCPTRowCheckboxChange = (index) => {
        if (labCPTAllCheckbox.includes(index)) {
            setlabCPTAllCheckbox(labCPTAllCheckbox.filter((selectedRow) => selectedRow !== index));



        } else {
            setlabCPTAllCheckbox([...labCPTAllCheckbox, index]);


        }
    };




    const handleSelectDiag4AllChange = () => {
        const allSelected = tableDetails.every((_, index) => diag4AllCheckbox.includes(index));

        if (allSelected) {
            // Deselect all checkboxes
            setDiag4AllCheckbox([]);

        } else {
            // Select all checkboxes
            setDiag4AllCheckbox(Array.from({ length: tableDetails.length }, (_, index) => index));




            console.log("selectedAllrows", diag4AllCheckbox);
        }
    };


    const handleDiag4RowCheckboxChange = (index) => {
        if (diag4AllCheckbox.includes(index)) {
            setDiag4AllCheckbox(diag4AllCheckbox.filter((selectedRow) => selectedRow !== index));



        } else {
            setDiag4AllCheckbox([...diag4AllCheckbox, index]);


        }
    };

    const handleSelectDiag3AllChange = () => {
        const allSelected = tableDetails.every((_, index) => diag3AllCheckbox.includes(index));

        if (allSelected) {
            // Deselect all checkboxes
            setDiag3AllCheckbox([]);

        } else {
            // Select all checkboxes
            setDiag3AllCheckbox(Array.from({ length: tableDetails.length }, (_, index) => index));




            console.log("selectedAllrows", diag3AllCheckbox);
        }
    };


    const handleDiag3RowCheckboxChange = (index) => {
        if (diag3AllCheckbox.includes(index)) {
            setDiag3AllCheckbox(diag3AllCheckbox.filter((selectedRow) => selectedRow !== index));




        } else {
            setDiag3AllCheckbox([...diag3AllCheckbox, index]);



        }
    };


    const handleSelectDiag2AllChange = () => {
        const allSelected = tableDetails.every((_, index) => diag2AllCheckbox.includes(index));

        if (allSelected) {
            // Deselect all checkboxes
            setDiag2AllCheckbox([]);

        } else {
            // Select all checkboxes
            setDiag2AllCheckbox(Array.from({ length: tableDetails.length }, (_, index) => index));



            console.log("selectedAllrows", diag2AllCheckbox);
        }
    };


    const handleDiag2RowCheckboxChange = (index) => {
        if (diag2AllCheckbox.includes(index)) {
            setDiag2AllCheckbox(diag2AllCheckbox.filter((selectedRow) => selectedRow !== index));




        } else {
            setDiag2AllCheckbox([...diag2AllCheckbox, index]);



        }
    };



    const handleSelectDiag1AllChange = () => {
        const allSelected = tableDetails.every((_, index) => diag1AllCheckbox.includes(index));

        if (allSelected) {
            // Deselect all checkboxes
            setDiag1AllCheckbox([]);

        } else {
            // Select all checkboxes
            setDiag1AllCheckbox(Array.from({ length: tableDetails.length }, (_, index) => index));




            console.log("selectedAllrows", diag1AllCheckbox);
        }
    };


    const handleDiag1RowCheckboxChange = (index) => {
        if (diag1AllCheckbox.includes(index)) {
            setDiag1AllCheckbox(diag1AllCheckbox.filter((selectedRow) => selectedRow !== index));




        } else {
            setDiag1AllCheckbox([...diag1AllCheckbox, index]);
            setSelectedRows([...selectedRows, index]);


        }
    };


    const handleSelectMod3AllChange = () => {
        const allSelected = tableDetails.every((_, index) => mod3AllCheckbox.includes(index));

        if (allSelected) {
            // Deselect all checkboxes
            setMod3AllCheckbox([]);
            setSelectedRows([]);
        } else {
            // Select all checkboxes
            setMod3AllCheckbox(Array.from({ length: tableDetails.length }, (_, index) => index));

            setSelectedRows(Array.from({ length: tableDetails.length }, (_, index) => index));


            console.log("selectedAllrows", mod3AllCheckbox);
        }
    };


    const handleMod3RowCheckboxChange = (index) => {
        if (mod3AllCheckbox.includes(index)) {
            setMod3AllCheckbox(mod3AllCheckbox.filter((selectedRow) => selectedRow !== index));



        } else {
            setMod3AllCheckbox([...mod3AllCheckbox, index]);


        }
    };





    const handleSelectMod2AllChange = () => {
        const allSelected = tableDetails.every((_, index) => mod2AllCheckbox.includes(index));

        if (allSelected) {
            // Deselect all checkboxes
            setMod2AllCheckbox([]);

        } else {
            // Select all checkboxes
            setMod2AllCheckbox(Array.from({ length: tableDetails.length }, (_, index) => index));




            console.log("selectedAllrows", mod2AllCheckbox);
        }
    };


    const handleMod2RowCheckboxChange = (index) => {
        if (mod2AllCheckbox.includes(index)) {
            setMod2AllCheckbox(mod2AllCheckbox.filter((selectedRow) => selectedRow !== index));



        } else {
            setMod2AllCheckbox([...mod2AllCheckbox, index]);


        }
    };



    const handleSelectMod1AllChange = () => {
        const allSelected = tableDetails.every((_, index) => mod1AllCheckbox.includes(index));

        if (allSelected) {
            // Deselect all checkboxes
            setMod1AllCheckbox([]);

        } else {
            // Select all checkboxes
            setMod1AllCheckbox(Array.from({ length: tableDetails.length }, (_, index) => index));




            console.log("selectedAllrows", mod1AllCheckbox);
        }
    };


    const handleMod1RowCheckboxChange = (index) => {
        if (mod1AllCheckbox.includes(index)) {
            setMod1AllCheckbox(mod1AllCheckbox.filter((selectedRow) => selectedRow !== index));



        } else {
            setMod1AllCheckbox([...mod1AllCheckbox, index]);


        }
    };



    const handleSelectCPTAllChange = () => {
        const allSelected = tableDetails.every((_, index) => cptAllCheckbox.includes(index));

        if (allSelected) {
            // Deselect all checkboxes
            setCptAllCheckbox([]);

        } else {
            // Select all checkboxes
            setCptAllCheckbox(Array.from({ length: tableDetails.length }, (_, index) => index));




            console.log("selectedAllrows", cptAllCheckbox);
        }
    };


    const handleCPTRowCheckboxChange = (index) => {
        if (cptAllCheckbox.includes(index)) {
            setCptAllCheckbox(cptAllCheckbox.filter((selectedRow) => selectedRow !== index));



        } else {
            setCptAllCheckbox([...cptAllCheckbox, index]);


        }
    };



    const handleSelectProviderAllChange = () => {
        const allSelected = tableDetails.every((_, index) => providerAllCheckbox.includes(index));

        if (allSelected) {
            // Deselect all checkboxes
            setProviderAllCheckbox([]);

        } else {
            // Select all checkboxes
            setProviderAllCheckbox(Array.from({ length: tableDetails.length }, (_, index) => index));




            console.log("selectedAllrows", providerAllCheckbox);
        }
    };


    const handleProviderRowCheckboxChange = (index, item) => {
        if (providerAllCheckbox.includes(index)) {
            setProviderAllCheckbox(providerAllCheckbox.filter((selectedRow) => selectedRow !== index));

        } else {
            setProviderAllCheckbox([...providerAllCheckbox, index]);


        }



    };




    const handleSelectInsuranceAllChange = () => {



        const allSelected = tableDetails.every((_, index) => insuranceAllCheckbox.includes(index));

        if (allSelected) {
            // Deselect all checkboxes
            setInsuranceAllCheckbox([]);

        } else {
            // Select all checkboxes
            setInsuranceAllCheckbox(Array.from({ length: tableDetails.length }, (_, index) => index));




            console.log("selectedAllrows", insuranceAllCheckbox);
        }
    };


    const handleInsuranceRowCheckbox = (index, item) => {

        setClaimID(item.ClaimId)


        if (insuranceAllCheckbox.includes(index)) {
            // If the row is already selected, unselect it
            setInsuranceAllCheckbox(insuranceAllCheckbox.filter((selectedRow) => selectedRow !== index));

        } else {
            // If the row is not selected, select it
            setInsuranceAllCheckbox([...insuranceAllCheckbox, index]);

        }
    };
    console.log("selectedrows", insuranceAllCheckbox);


    useEffect(() => {

    }, [insuranceAllCheckbox]);









    const handleOpenModal = () => {
        if (selectedRows.length === 0) {
            // Show error modal if no rows are selected



            setShowSelectErrorModal(true);
        } else {
            // Show confirm save modal if rows are selected

            setShowConfirmSaveModal(true);
        }
    };





    const handleICDOpenModal = () => {
        if (
            diag1AllCheckbox.length === 0 &&
            diag2AllCheckbox.length === 0 &&
            diag3AllCheckbox.length === 0 &&
            diag4AllCheckbox.length === 0
        ) {

            setShowICDErrorModal(true);
        } else {


            setICDConfirmSaveModal(true);
        }
    };




    const handleOpenApprovalModal = () => {
        if (selectedRows.length === 0) {
            // Show error modal if no rows are selected



            setShowSelectErrorModal(true);
        } else {
            // Show confirm save modal if rows are selected

            setShowApprovalSaveModal(true);
        }
    };

    const handleCloseClaimModal = () => {

        setCloseClaimsModal(true);

    }




    const handleCloseModals = () => {
        // Close all modals
        setShowSelectErrorModal(false);
        setShowConfirmSaveModal(false);
        setShowSuccessModal(false);
        setShowDeleteModal(false);
        setShowApprovalSaveModal(false);
        setCloseClaimsModal(false);
        setShowFaxModal(false);
        setShowICDErrorModal(false);
        setICDConfirmSaveModal(false)
        setIsEPINVerifiedModal(false);
    };


    const handleOpenDeleteModal = () => {
        if (selectedRows.length === 0) {


            setShowSelectErrorModal(true);
        } else {


            setShowDeleteModal(true);
        }
    };




    const handleDelete = () => {

        resetDialogValues()


        const updatedRows = tableDetails.filter((row, index) => !selectedRows.includes(index));

        setTableDetails(updatedRows);
        console.log("deletetablerows", updatedRows);

        setShowDeleteModal(false)
        setDeleteSuccessModal(true)
        setSelectedRows([]);
        setDeleteRowCount(selectedRows.length);

    };






    const DeleteclaimICDDetails = async () => {



        const JsonDataArr = [];

        [diag1AllCheckbox, diag2AllCheckbox, diag3AllCheckbox, diag4AllCheckbox].forEach((checkboxArray, index) => {
            checkboxArray.forEach(rowIndex => {
                const item = tableDetails[rowIndex];
                const clmnName = index === 0 ? "Diag1" : index === 1 ? "Diag2" : index === 2 ? "Diag3" : "Diag4";

                const input = {

                    claimid: item.ClaimId + "",
                    patientid: item.PatientId + "",
                    procedure: item.CPT,
                    practiceid: "",
                    DOS: item.DOS + "",
                    clmnName: clmnName


                }



                console.log("selectedData", input);

                JsonDataArr.push(input)

            });
        });

        const requestData = {
            JsonDataArr: JsonDataArr,
            LoggedInUserDetails: userData
        };




        var myInput = { sInputJSON: JSON.stringify(requestData) };
        console.log("inputRow of" + IntelliBillConstants.DeleteclaimICDDetails, myInput);
        myInput = JSON.stringify(myInput);


        try {


            const response = await fetch(APIConstants.BASE_URL + IntelliBillConstants.DeleteclaimICDDetails, {
                method: 'POST',


                headers: {

                    'Accept': 'application/json',
                    'Content-Type': 'application/json'

                },

                body: myInput
            })


            if (response.ok) {
                const responseData = await response.json();


                const parsedData = JSON.parse(responseData.d);


                console.log("SelectedRespData of" + IntelliBillConstants.DeleteclaimICDDetails, responseData);
                setICDConfirmSaveModal(false)
                handleTableDataClick();
                setDiag1AllCheckbox([])
                setDiag2AllCheckbox([])
                setDiag3AllCheckbox([])
                setDiag4AllCheckbox([])

            } else {
                console.error('Error sending data to the API');



            }





        } catch (error) {
            console.error('An error occurred:', error);

        }


    };









    const [showPassword, setShowPassword] = useState(false);

    const handleTogglePassword = () => {
        setShowPassword(!showPassword);
    };



    useEffect(() => {

        resetDialogValues()

    }, [])
    //Add the row in DialogBox




    const handleRemoveRow = (index) => {
        // Remove the row at the specified index
        setRows((prevRows) => prevRows.filter((_, i) => i !== index));
        resetDialogValues();
    };


    const handleSave = () => {

        setFilteredTableDetails((prevRows) => [...prevRows, ...rows]);


        setRows([]);

        setShowFaxModal(false);
    };




    const handleSyncedInputChange = (e) => {
        const newValue = e.target.value;
        setSyncedValue(newValue);

        const updatedRows = [...filteredTableDetails];
        unitCheckbox.forEach((index) => {
            updatedRows[index].Unit = newValue;
            let totalCharge = newValue * filteredTableDetails[index].Unitcharge;
            updatedRows[index].TotalCharge = parseFloat(totalCharge.toFixed(2));
        });

        setFilteredTableDetails(updatedRows);

    };





    const handleUnitChange = (index, newValue) => {
        const updatedRows = [...filteredTableDetails];
        updatedRows[index].Unit = newValue;

        let totalCharge = newValue * filteredTableDetails[index].Unitcharge;

        if (totalCharge == 0) {
            totalCharge = parseFloat(totalCharge.toFixed(2));
        }
        updatedRows[index].TotalCharge = totalCharge;
        setFilteredTableDetails(updatedRows);



    };






    const handleSyncedUnitCharge = (e) => {
        const newValue = e.target.value;
        setSyncedUnitchargeVal(newValue);

        const updatedRows = [...filteredTableDetails];
        UnitChargeRows.forEach((index) => {
            updatedRows[index].Unitcharge = newValue;
            let totalCharge = newValue * filteredTableDetails[index].Unit;
            updatedRows[index].TotalCharge = parseFloat(totalCharge.toFixed(2));
        });

        setFilteredTableDetails(updatedRows);

    };



    const handleUnitchargeChange = (index, newValue) => {
        const updatedRows = [...filteredTableDetails];
        updatedRows[index].Unitcharge = newValue;

        let totalCharge = filteredTableDetails[index].Unit * newValue;

        if (totalCharge == 0) {
            totalCharge = parseFloat(totalCharge.toFixed(2));
        }
        updatedRows[index].TotalCharge = totalCharge;
        setFilteredTableDetails(updatedRows);
    };



    const handleTotalChargeChange = (index, newValue) => {
        const updatedRows = [...filteredTableDetails];
        updatedRows[index].TotalCharge = newValue === '' ? '' : newValue;
        setFilteredTableDetails(updatedRows);
    };





    const handleTotalChargeKeyDown = (index, e) => {
        if (e.key === 'Backspace') {
            e.preventDefault();
            const updatedRows = [...filteredTableDetails];
            updatedRows[index].TotalCharge = '';
            setFilteredTableDetails(updatedRows);
        }
    };









    const handleRowClick = (index) => {
        setActiveRow(index);
    };





    const handlePrint = () => {

        if (!tableRef.current) {
            console.error("Table reference is not set.");
            return;
        }

        setFilteredTableDetails(tableDetails);
        const prevVisibleCount = filteredTableDetails;

        setTimeout(() => {
            const tableHTML = tableRef.current.outerHTML;
            const printWindow = window.open("", "_blank");

            printWindow.document.writeln(`
            <html>
              <head>
                <title class="print-title">Super Bill</title>
                <style>
                  body {
                    font-family: Arial, sans-serif;
                    margin: 10px;
                    font-size: 15px;
                    color: #000;
                  }
      
                  .print-title {
                    text-align: center;
                    font-size: 24px;
                    font-weight: bold;
                    margin-bottom: 20px;
                    color: #0173b7;
                  }
      
                  .table-container {
                    width: 100%;
                    overflow-x: auto;
                  }
      
                  table {
                    width: 100%;
                    border-collapse: collapse;
                    table-layout: auto; 
                    word-wrap: break-word;
                  }
      
                  th, td {
                    border: 1px solid black;
                    padding: 5px;
                    text-align: left;
                    font-size: 15px;
                  }
      
                  th {
                    background-color: #f4f4f4;;
                    font-size: 15px;
                    color: black !important;
                    border: 1px solid black;
                    text-align: top;
                    transform-origin: left bottom;
                    height: 120px;
                    
                  }
                  td{
                      font-size:14px
                    }
      
                  @media print {
                    @page {
                      size: A3 landscape;
                      margin: 10mm;
                    }
      
                    .table-container {
                      overflow: visible !important;
                    }
      
                     .hv-hide-on-print {
                      display: none !important;
                    }


                    .hv-t-red{
                      width: 20px !important;
                      color: black;

                    }

                   
                    .show-on-print {
                        width: 30px;
                    }

                    .print-label {

                       display: inline-block;
                        max-width: 40px; 
                        word-wrap: break-word;
                        white-space: normal !important;
                        overflow-wrap: break-word;
                        font-size: 12px;
                     }
                  }
      
                  body {
                      -webkit-print-color-adjust: exact;
                    }
                  }
                </style>
              </head>
              <body>
               
                <div class="table-container">${tableHTML}</div>
                <script>
                  window.onload = function() {
                    window.print();
                  };
                  window.onafterprint = function() {
                    window.close();
                  };
                </script>
              </body>
            </html>
          `);

            printWindow.document.close();
            setTimeout(() => {
                setFilteredTableDetails(prevVisibleCount);
            }, 10);
        }, 10);
    };



    const tableRef = useRef('');

    const getPrintableData = () => {
        // Build table header
        let htmlData = `
  <table border="1" style="border-collapse:collapse;width:100%">
    <thead style="background-color:#0173b7;color:white;">
      <tr>
        <th>#</th>
        <th>Location</th>
        <th>DOS</th>
        <th>App Time</th>
        <th>Invoice#</th>
        <th>Patient Name</th>
        <th>DOB</th>
        <th>Insurance</th>
        <th>Provider</th>
        <th>CPT</th>
        <th>Units</th>
        <th>ICD</th>
        <th>Mod</th>
        <th>Counselor</th>
        <th>COU-CPT</th>
        <th>COU-Units</th>
        <th>COU-ICD</th>
        <th>COU-Mod</th>
        <th>Lab CPT</th>
        <th>Lab ICD</th>
        <th>Nurse</th>
        <th>Nurse CPT</th>
        <th>Nurse Units</th>
        <th>Nurse ICD</th>
        <th>Claim#</th>
      </tr>
    </thead>
    <tbody>
  `;

        // Add table rows
        filteredTableDetails.forEach((item, index) => {
            htmlData += `
      <tr>
        <td>${index + 1}</td>
        <td>${item.LocationName || ''}</td>
        <td>${item.DOS ? formatDOSDate(item.DOS) : ''}</td>
        <td>${item.fromTimeAMPM || ''}</td>
        <td>${item.PracticeInvoiceNumber || ''}</td>
        <td>${item.PatientName || ''}</td>
        <td>${item.DOB || ''}</td>
        <td>${item.Insurance || ''}</td>
        <td>${item.FinalProviderName || ''}</td>
        <td>${item.ProviderCPT || ''}</td>
        <td>${item.ProviderCPTUnits || ''}</td>
        <td>${item.ICD || ''}</td>
        <td>${item.Modifier || ''}</td>
        <td>${item.CounselorName || ''}</td>
        <td>${item.CouCPT || ''}</td>
        <td>${item.CounselorCPTUnits || ''}</td>
        <td>${item.CouICD || ''}</td>
        <td>${item.CouModifier || ''}</td>
        <td>${item.LabCPT || ''}</td>
        <td>${item.LabICD || ''}</td>
        <td>${item.NurseName || ''}</td>
        <td>${item.NurseCPT || ''}</td>
        <td>${item.NurseCPTUnits || ''}</td>
        <td>${item.NurseICD || ''}</td>
        <td>${item.ClaimID || ''}</td>
      </tr>
    `;
        });

        htmlData += `</tbody></table>`;
        return htmlData
    };

    const exportToExcel = async () => {
        const pagename = 'SuperBill';
        let sPrintableData = getPrintableData();

        const PrintableDataDetails = {
            PrintableData: sPrintableData,
            PageName: pagename,
        };
        const InputJSON = JSON.stringify(JSON.stringify(PrintableDataDetails));
        try {
            const response = await fetch(APIConstants.SERVICES_URL + FilesAPIConstants.ExcelFile, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: InputJSON,
            });
            const data = await response.json();
            if (data && data[2]) {
                window.open(data[2], '_blank');
            }
        } catch (error) {
            console.error('Export to Excel failed', error);
        }
    };





    const exportToPDF = () => {
        const pagename = 'SuperBill';
        setFilteredTableDetails(tableDetails);
        const prevVisibleCount = filteredTableDetails;

        setTimeout(() => {
            const table = tableRef.current.parentNode;
            let sPrintableData = table ? table.innerHTML : '';

            const vRegEx = new RegExp("gvClosedClaims", "");
            sPrintableData = sPrintableData.replace(vRegEx, "gvAcceptdClaims");

            console.log('Table HTML:', sPrintableData);

            const PrintableDataDetails = {
                PrintableData: sPrintableData,
                PageName: pagename,
            };

            const InputJSONLevelOne = JSON.stringify(PrintableDataDetails);
            const InputJSON = JSON.stringify(InputJSONLevelOne);

            console.log("Input of Excel", InputJSON);

            fetch(APIConstants.SERVICES_URL + FilesAPIConstants.ExportPdfFile, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: InputJSON,
            })
                .then(response => response.json()) // Parse the response as JSON
                .then(data => {
                    console.log('API response:' + FilesAPIConstants.ExportPdfFile, data);

                    if (data && data[2]) {

                        const url = data[2];
                        window.open(url, '_blank');


                    }
                })
                .catch(err => console.error('Export to PDF failed', err))
                .finally(() => {

                    setFilteredTableDetails(prevVisibleCount);
                });

        }, 100);
    };








    const GetProviderPDF = (item) => {

        console.log("PDF Data", item);


        const claimFilters = {
            AddedUserID: item.AddedUserID,
            iPracticeID: userPracticeID,
            AddedUserRoleID: item.AddedUserRoleID,
            sPatientID: item.PatientID,
            sFromDate: item.DOS,
            sCPT: item.ProviderCPT
        };


        const sInputJSON = JSON.stringify(claimFilters);

        console.log("Input of PDF" + FilesAPIConstants.PdfFile, sInputJSON);

        const url = `${APIConstants.BASE_URL_BILLING}${FilesAPIConstants.PdfFile}?sInputJSON=${sInputJSON}`;

        console.log("URL: ", url);

        fetch(url, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        })

            .then(response => response.json()) // Parse the response as JSON
            .then(data => {
                console.log('API response:' + FilesAPIConstants.PdfFile, data);

                if (data && data[0]) {

                    const url = JSON.parse(data);
                    window.open(url[0], '_blank');


                }
            })
            .catch(error => {
                console.error(' PDF failed', error);
            });
    };




    useEffect(() => {
        console.log("Selected CMS 33a:", selectedCMS33a);
    }, [selectedCMS33a]);


    useEffect(() => {
        console.log("Selected CMS 33b:", selectedCMS33b);
    }, [selectedCMS33b]);





    const handleDosLinkClick = (item) => {
        const claimId = item.ClaimID;

        localStorage.setItem('selectedClaimItem', JSON.stringify(item));

        const url = `/#/transactionlogs/${claimId}`;
        window.open(url, '_blank');
    };



    const handlePatLinkClick = (item) => {
        const url = `/#/patientdashboard/${item.PatientID}/primary-insurance`;

        console.log("SuperbillPatientID>>>", item.PatientID);
        localStorage.setItem("PatientID", item.PatientID);

        window.open(url, '_blank');
    };




    const handleLinkClick = (item) => {
        const url = `/#/new-encounter/${item.ClaimID}`;
        window.open(url, '_blank');
    };






    const handleProviderRadioChange = (event) => {
        setSelectedProviderRadio(event.target.value);
    };




    useEffect(() => {

        handleTableDataClick();
       
    }, [selectedProviderRadio])






    const handleSortByDos = () => {

        const sortedTableDetails = [...filteredTableDetails].sort((a, b) => {
            const dateA = new Date(a.DOS);
            const dateB = new Date(b.DOS);

            if (sortDosDate === 'asc') {
                return dateA - dateB;
            } else {
                return dateB - dateA;
            }
        });

        // Toggle sorting order for the next click
        setSortDosDate(sortDosDate === 'asc' ? 'desc' : 'asc');

        // Update table provider with sorted data
        setFilteredTableDetails(sortedTableDetails);

    };






    const handleSortByPatname = () => {
        const sortedData = [...filteredTableDetails].sort((a, b) => {
            if (sortPatName === 'asc') {
                return a.PatientName.localeCompare(b.PatientName);
            } else {
                return b.PatientName.localeCompare(a.PatientName);
            }
        });

        setFilteredTableDetails(sortedData);
        setSortPatName(sortPatName === 'asc' ? 'desc' : 'asc');
    };








    const handleSortByLocation = () => {
        const sortedData = [...filteredTableDetails].sort((a, b) => {
            if (sortLocationName === 'asc') {
                return a.LocationName.localeCompare(b.LocationName);
            } else {
                return b.LocationName.localeCompare(a.LocationName);
            }
        });

        setFilteredTableDetails(sortedData);
        setSortLocationName(sortLocationName === 'asc' ? 'desc' : 'asc');
    };





    useEffect(() => {
        const filteredData = tableDetails.filter(item =>

            (!searchByDOS || (item.DOS && typeof item.DOS === 'string' && item.DOS.toLowerCase().includes(searchByDOS.toLowerCase()))) &&

            (!searchByLocationName || (item.LocationName && typeof item.LocationName === 'string' && item.LocationName.toLowerCase().includes(searchByLocationName.toLowerCase()))) &&

            (!searchByPatient || (item.PatientName && typeof item.PatientName === 'string' &&
                (item.PatientName.toLowerCase().startsWith(searchByPatient.toLowerCase()) ||
                    item.PatientName.toLowerCase().includes(` ${searchByPatient.toLowerCase()}`)))) &&


            (!searchBySUD || (item.ScheduleType && typeof item.ScheduleType === 'string' && item.ScheduleType.toLowerCase().includes(searchBySUD.toLowerCase())) ||
                (item.CouAppType && typeof item.CouAppType === 'string' && item.CouAppType.toLowerCase().includes(searchBySUD.toLowerCase()))) &&




            (!searchByDOB || (item.DOB && typeof item.DOB === 'string' && item.DOB.toLowerCase().includes(searchByDOB.toLowerCase()))) &&

            (!searchByInsuranceID || (item.Insurance && typeof item.Insurance === 'string' && item.Insurance.toLowerCase().includes(searchByInsuranceID.toLowerCase()))) &&

            (!searchByInvoice || (item.PracticeInvoiceNumber && typeof item.PracticeInvoiceNumber === 'string' && item.PracticeInvoiceNumber.toLowerCase().includes(searchByInvoice.toLowerCase()))) &&

            (!searchByProvider || (item.FinalProviderName && typeof item.FinalProviderName === 'string' && item.FinalProviderName.toLowerCase().includes(searchByProvider.toLowerCase()))) &&
            (!searchByCounselor || (item.CounselorName && typeof item.CounselorName === 'string' && item.CounselorName.toLowerCase().includes(searchByCounselor.toLowerCase()))) &&
            (!searchByCouCPT || (item.CouCPT && typeof item.CouCPT === 'string' && item.CouCPT.toLowerCase().includes(searchByCouCPT.toLowerCase()))) &&
            (!searchByLabCPT || (item.LabCPT && typeof item.LabCPT === 'string' && item.LabCPT.toLowerCase().includes(searchByLabCPT.toLowerCase()))) &&
            (!searchByNurseCPT || (item.NurseCPT && typeof item.NurseCPT === 'string' && item.NurseCPT.toLowerCase().includes(searchByNurseCPT.toLowerCase()))) &&
            (!searchByCPT || (item.ProviderCPT && typeof item.ProviderCPT === 'string' && item.ProviderCPT.toLowerCase().includes(searchByCPT.toLowerCase()))) &&

            (!searchByNurseName || (item.NurseName && typeof item.NurseName === 'string' && item.NurseName.toLowerCase().includes(searchByNurseName.toLowerCase()))) &&

            (!searchByMod1 || (item.Modifier && typeof item.Modifier === 'string' && item.Modifier.toLowerCase().includes(searchByMod1.toLowerCase()))) &&
            (!searchByMod2 || (item.Mod2 && typeof item.Mod2 === 'string' && item.Mod2.toLowerCase().includes(searchByMod2.toLowerCase()))) &&
            (!searchByMod3 || (item.Mod3 && typeof item.Mod3 === 'string' && item.Mod3.toLowerCase().includes(searchByMod3.toLowerCase()))) &&


            (!searchByICD1 || (item.ICD && typeof item.ICD === 'string' && item.ICD.toLowerCase().includes(searchByICD1.toLowerCase()))) &&
            (!searchByICD2 || (item.CouICD && typeof item.CouICD === 'string' && item.CouICD.toLowerCase().includes(searchByICD2.toLowerCase()))) &&
            (!searchByICD3 || (item.ICDCode3 && typeof item.ICDCode3 === 'string' && item.ICDCode3.toLowerCase().includes(searchByICD3.toLowerCase()))) &&
            (!searchByICD4 || (item.LabICD && typeof item.LabICD === 'string' && item.LabICD.toLowerCase().includes(searchByICD4.toLowerCase())))
        );


        setFilteredTableDetails(searchByDOS || searchByPatient || searchByDOB || searchByProvider || searchBySUD || searchByInsuranceID
            || searchByCPT || searchByMod1 || searchByMod2 || searchByMod3 || searchByICD1 || searchByICD2 || searchByICD3 || searchByICD4 || searchByCounselor || searchByCouCPT
            || searchByLabCPT || searchByInvoice || searchByNurseName || searchByNurseCPT || searchByLocationName
            ? filteredData : tableDetails);

    }, [tableDetails, searchByDOS, searchByPatient, searchByDOB, searchByProvider, searchByCPT, searchBySUD, searchByInsuranceID, searchByLocationName,
        searchByMod1, searchByMod2, searchByMod3, searchByICD1, searchByICD2, searchByICD3, searchByICD4, , searchByCounselor, searchByCouCPT
        , searchByLabCPT, searchByInvoice, searchByNurseName, searchByNurseCPT]);









    const inputRef = useRef(null); // To track the input
    const suggestionsRef = useRef(null); // To track the suggestions container

    const handleClickOutside = (event) => {
        // Check if the click was outside both input and suggestions
        if (
            inputRef.current &&
            !inputRef.current.contains(event.target) &&
            suggestionsRef.current &&
            !suggestionsRef.current.contains(event.target)
        ) {
            setSuggestions([]); // Clear the suggestions to close the list
        }
    };

    useEffect(() => {
        if (suggestions.length > 0) {
            // Only add the event listener when suggestions are visible
            document.addEventListener('mousedown', handleClickOutside);
        } else {
            // Remove event listener when suggestions are hidden
            document.removeEventListener('mousedown', handleClickOutside);
        }

        // Cleanup: Remove the event listener when the component unmounts
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [suggestions]);













    const getRowHeight = index => {

        const item = filteredTableDetails[index];
        return item?.DataValidationMessage ? 100 : 50;
    };




    const fmtDate = (d) => {
        if (!d) return "";
        const date = new Date(d);
        return isNaN(date) ? "" : format(date, "MM/dd/yyyy");
    };

    // ── Pagination ─────────────────────────────────────────────
    // Page size mirrors the "Show" toggle (25/50/75/100); "all" means one
    // page holding every row. Rows keep their index into filteredTableDetails
    // (not a page-local index) so every existing checkbox/select-all handler
    // — which all key off that index — keeps working unchanged; only which
    // rows render is limited here.
    const pageSize = viewLimit === "all" ? Math.max(filteredTableDetails.length, 1) : Number(viewLimit);
    const totalPages = viewLimit === "all" ? 1 : Math.max(1, Math.ceil(filteredTableDetails.length / pageSize));
    const pageStart = (currentPage - 1) * pageSize;
    const pageEnd = pageStart + pageSize;

    // Reset to page 1 whenever the filtered result set or page size changes,
    // so pagination never gets stuck past the end of a shorter result set.
    useEffect(() => {
        setCurrentPage(1);
    }, [filteredTableDetails, viewLimit]);

    // Clicking a row highlights it; clear that highlight when the page or
    // tab changes so it never points at a row that's no longer visible.
    useEffect(() => {
        setActiveRow(null);
    }, [activeTab, currentPage]);

    return (
        <div className="hv-page">
            <div className="hv-container">

                {/* ─── Page header band ─── */}
                <header className="hv-pagehead">
                    <div>
                        <h1 className="hv-pagehead__title">Super Bill</h1>
                    </div>
                    <div className="hv-pagehead__actions">
                        <span className="hv-pill hv-pill--neutral">{filteredTableDetails.length} Records</span>
                    </div>
                </header>

                {/* ─── Filters ─── */}
                <section className="hv-toolbar" aria-label="Filters">
                    <div className="hv-toolbar__group">
                        <label className="hv-field__label">From:</label>
                        <DatePicker
                            className="hv-date"
                            selected={startDate ? new Date(startDate) : null}
                            onChange={handleStartDateChange}
                            dateFormat="MM/dd/yyyy"
                            maxDate={new Date()}
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            yearDropdownItemNumber={100}
                            readOnly={isHideChecked}
                            placeholderText="MM/dd/yyyy"
                            calendarContainer={CalendarStartContainer}
                            open={isStartOpen}
                            onFocus={() => setIsStartOpen(true)}
                            onInputClick={() => setIsStartOpen(true)}
                            onClickOutside={() => setIsStartOpen(false)}
                            renderCustomHeader={renderCalendarHeader}
                            popperPlacement="bottom-start"
                        />
                        <label className="hv-field__label">To:</label>
                        <DatePicker
                            className="hv-date"
                            selected={endDate ? new Date(endDate) : null}
                            onChange={handleEndDateChange}
                            dateFormat="MM/dd/yyyy"
                            maxDate={new Date()}
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            yearDropdownItemNumber={100}
                            placeholderText="MM/dd/yyyy"
                            popperPlacement="bottom-start"
                            readOnly={isHideChecked}
                            calendarContainer={CalendarContainer}
                            open={isEndOpen}
                            onFocus={() => setIsEndOpen(true)}
                            onInputClick={() => setIsEndOpen(true)}
                            onClickOutside={() => setIsEndOpen(false)}
                            renderCustomHeader={renderCalendarHeader}
                        />
                    </div>

                    <div className="hv-toolbar__group">
                        <label className="hv-field__label">Location:</label>
                        <select
                            name="select"
                            className="hv-select"
                            style={{
                                backgroundColor:
                                    searchByLoaction !== '-1'
                                        ? (locations.find((loc) => loc.LocationId == searchByLoaction)?.Color || '#fff')
                                        : '#fff'
                            }}
                            value={searchByLoaction}
                            onChange={handleLocationChange}
                        >
                            <option value="-1">All</option>
                            {locations.map((item, index) => (
                                <option key={index} value={item.LocationId} style={{ backgroundColor: item.Color, color: 'white' }}>{item.LocationName}</option>
                            ))}
                        </select>
                    </div>

                    <div className="hv-toolbar__group">
                        <label className="hv-check">
                            <input type="radio" name="option" value="0" checked={selectedProviderRadio === "0"} onChange={handleProviderRadioChange} />
                            <span>All</span>
                        </label>
                        <label className="hv-check">
                            <input type="radio" name="option" value="1" checked={selectedProviderRadio === "1"} onChange={handleProviderRadioChange} />
                            <span>Lab</span>
                        </label>
                        <label className="hv-check">
                            <input type="radio" name="option" value="2" checked={selectedProviderRadio === "2"} onChange={handleProviderRadioChange} />
                            <span>Provider</span>
                        </label>
                        <label className="hv-check">
                            <input type="radio" name="option" value="3" checked={selectedProviderRadio === "3"} onChange={handleProviderRadioChange} />
                            <span>Counselor</span>
                        </label>
                        <label className="hv-check">
                            <input type="radio" name="option" value="5" checked={selectedProviderRadio === "5"} onChange={handleProviderRadioChange} />
                            <span>Nurse</span>
                        </label>
                    </div>

                    <div className="hv-toolbar__group" style={{ position: 'relative' }}>
                        <label className="hv-field__label">Search By:</label>
                        <select name="select" className="hv-select" value={selectedSearchFilter} onChange={handleSuggestionChange}>
                            {searchFilterData.map((item, index) => (
                                <option key={item.sFilterType} value={item.sFilterType}>{item.Label}</option>
                            ))}
                        </select>
                        <input
                            type="text"
                            className="hv-input"
                            value={searchText}
                            ref={inputRef}
                            onChange={(e) => setSearchText(e.target.value)}
                            onKeyDown={handleInputKeyPress}
                            disabled={isTextBoxDisabled}
                            style={{ width: 140 }}
                        />
                        {suggestions.length > 0 && (
                            <ul className="hv-suggest" ref={suggestionsRef}>
                                {suggestions.map((suggestion) => (
                                    <li key={suggestion.val} className="hv-suggest__item" onClick={() => handleSuggestionSelect(suggestion)}>
                                        {suggestion.label}
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>

                    <button type="button" className="hv-icon-btn" title="Search" onClick={(e) => handleTableDataClick(e)}>
                        <FontAwesomeIcon icon={faMagnifyingGlass} />
                    </button>

                    <div className="hv-spacer" />

                    <div className="hv-btn-group">
                        <button type="button" className="hv-btn hv-btn--ghost hv-btn--sm" title="Print" onClick={handlePrint}>
                            <FontAwesomeIcon icon={faPrint} />
                            <span>Print</span>
                        </button>
                        <button type="button" className="hv-btn hv-btn--ghost hv-btn--sm" title="Download as Excel" onClick={exportToExcel}>
                            <FontAwesomeIcon icon={faFileExcel} />
                            <span>Excel</span>
                        </button>
                        <button type="button" className="hv-btn hv-btn--ghost hv-btn--sm" title="Download as PDF" onClick={exportToPDF}>
                            <FontAwesomeIcon icon={faFilePdf} />
                            <span>PDF</span>
                        </button>
                    </div>
                </section>

                {/* ─── Superbill table card ─── */}
                <section className="hv-panel hv-panel--flush">
                    <nav className="hv-tabbar" role="tablist" aria-label="Superbill views">
                        <button
                            type="button"
                            role="tab"
                            aria-selected={activeTab === "provider"}
                            className={"hv-tabbar__tab" + (activeTab === "provider" ? " is-active" : "")}
                            onClick={() => setActiveTab("provider")}
                        >
                            🏥 Provider Info
                        </button>
                        <button
                            type="button"
                            role="tab"
                            aria-selected={activeTab === "counselor"}
                            className={"hv-tabbar__tab" + (activeTab === "counselor" ? " is-active" : "")}
                            onClick={() => setActiveTab("counselor")}
                        >
                            👤 Counselor Info
                        </button>
                        <button
                            type="button"
                            role="tab"
                            aria-selected={activeTab === "lab"}
                            className={"hv-tabbar__tab" + (activeTab === "lab" ? " is-active" : "")}
                            onClick={() => setActiveTab("lab")}
                        >
                            📋 Lab Info
                        </button>
                        <button
                            type="button"
                            role="tab"
                            aria-selected={activeTab === "nurse"}
                            className={"hv-tabbar__tab" + (activeTab === "nurse" ? " is-active" : "")}
                            onClick={() => setActiveTab("nurse")}
                        >
                            🩺 Nurse Info
                        </button>
                        <button
                            type="button"
                            role="tab"
                            aria-selected={activeTab === "all"}
                            className={"hv-tabbar__tab" + (activeTab === "all" ? " is-active" : "")}
                            onClick={() => setActiveTab("all")}
                        >
                            <FontAwesomeIcon icon={faTable} />
                            All
                        </button>
                    </nav>

                    <div className="hv-tablebar">
                        <span className="hv-row hv-row--tight">
                            <span className="hv-t-lg hv-t-black hv-num hv-t-teal">
                                {Math.min(filteredTableDetails.length, pageEnd) - Math.min(filteredTableDetails.length, pageStart)}
                            </span>
                            <span className="hv-t-xs hv-t-bold hv-t-upper">
                                of {filteredTableDetails.length} record{filteredTableDetails.length === 1 ? "" : "s"}
                            </span>
                        </span>

                        <span className="hv-row hv-row--tight">
                            <span className="hv-t-xs hv-t-bold hv-t-upper">Show</span>
                            <div className="hv-seg">
                                {["25", "50", "75", "100", "all"].map((v) => (
                                    <button
                                        key={v}
                                        type="button"
                                        className={`hv-seg__btn ${viewLimit === v ? "is-active" : ""}`}
                                        onClick={() => setViewLimit(v)}
                                    >
                                        {v === "all" ? "All" : v}
                                    </button>
                                ))}
                            </div>
                        </span>
                    </div>

                    <div className="hv-table-scroll">
                        <table className="hv-table" ref={tableRef}>
                            <thead>
                                {activeTab === "provider" && (
                                    <tr>
                                        <th style={{ width: 32, textAlign: "center" }}>#</th>
                                        <th style={{ width: 30 }}>
                                            <button type="button" className="hv-sort" onClick={handleSortByLocation}>Location</button>
                                            <br />
                                            <input className="hv-th-search hv-hide-on-print" placeholder="Search"
                                                value={searchByLocationName}
                                                onChange={(e) => setSearchByLocationName(e.target.value)}
                                            />
                                        </th>
                                        <th style={{ width: 50 }}>
                                            <button type="button" className="hv-sort" onClick={handleSortByDos}>DOS</button>
                                            <br />
                                            <input className="hv-th-search" placeholder="Search"
                                                value={searchByDOS}
                                                onChange={(e) => setSearchByDOS(e.target.value)} />
                                        </th>
                                        <th style={{ width: 50 }}>
                                            <div className="hv-th-title">App Time</div>
                                        </th>
                                        <th style={{ width: 50 }}>
                                            <div className="hv-th-title">Invoice#</div>
                                            <input className="hv-th-search hv-hide-on-print" placeholder="Search"
                                                value={searchByInvoice}
                                                onChange={(e) => setSearchByInvoice(e.target.value)}
                                            />
                                        </th>
                                        <th style={{ width: 60 }}>
                                            <button type="button" className="hv-sort" onClick={handleSortByPatname}>Patient Name</button>
                                            <br />
                                            <input className="hv-th-search" placeholder="Search"
                                                value={searchByPatient}
                                                onChange={(e) => setSearchByPatient(e.target.value)} />
                                        </th>
                                        <th style={{ width: 50 }}>
                                            <div className="hv-th-title">DOB</div>
                                            <input className="hv-th-search" placeholder="Search"
                                                value={searchByDOB}
                                                onChange={(e) => setSearchByDOB(e.target.value)} />
                                        </th>
                                        <th style={{ width: 100 }}>
                                            <div className="hv-th-title">Insurance</div>
                                            <input className="hv-th-search" placeholder="Search"
                                                value={searchByInsuranceID}
                                                onChange={(e) => setSearchByInsuranceID(e.target.value)} />
                                        </th>
                                        <th style={{ width: 90 }}>
                                            <div className="hv-th-title">
                                                Provider
                                                <input type="checkbox" className="hv-th-check"
                                                    onChange={() => handleSelectProviderAllChange('all')}
                                                />
                                            </div>
                                            <select name="select" className="hv-select hv-select--sm hv-hide-on-print" onChange={handleSelectFilterProviders} value={selectedFilterProvider}>
                                                <option value="">&lt;--Select--&gt;</option>
                                                {filteredProviders.map(provider => (
                                                    <option key={provider.ProviderID} value={provider.ProviderID}>{provider.ProviderName}</option>
                                                ))}
                                            </select>
                                            <br />
                                            <input className="hv-th-search hv-hide-on-print" placeholder="Search"
                                                value={searchByProvider}
                                                onChange={(e) => setSearchByProvider(e.target.value)}
                                            />
                                        </th>
                                        <th style={{ width: 80, textAlign: "center" }}>
                                            <div className="hv-th-title">
                                                CPT
                                                <input type="checkbox" className="hv-th-check"
                                                    onChange={() => handleSelectCPTAllChange('all')}
                                                />
                                            </div>
                                            <input className="hv-th-search hv-hide-on-print" placeholder="Search"
                                                value={searchByCPT}
                                                onChange={(e) => setSearchByCPT(e.target.value)}
                                            />
                                        </th>
                                        <th style={{ width: 60 }}>
                                            <div className="hv-th-title">Units</div>
                                        </th>
                                        <th style={{ width: 60 }}>
                                            <div className="hv-th-title">
                                                ICD
                                                <input type="checkbox" className="hv-th-check"
                                                    onChange={() => handleSelectDiag1AllChange('all')}
                                                />
                                            </div>
                                            <input className="hv-th-search hv-hide-on-print" placeholder="Search"
                                                value={searchByICD1}
                                                onChange={(e) => setSearchByICD1(e.target.value)}
                                            />
                                        </th>
                                        <th style={{ width: 60 }}>
                                            <div className="hv-th-title">
                                                Mod
                                                <input type="checkbox" className="hv-th-check"
                                                    onChange={() => handleSelectMod1AllChange('all')}
                                                />
                                            </div>
                                            <input className="hv-th-search hv-hide-on-print" placeholder="Search"
                                                value={searchByMod1}
                                                onChange={(e) => setSearchByMod1(e.target.value)}
                                            />
                                        </th>
                                        <th style={{ width: 50 }}>
                                            <div className="hv-th-title">Claim #</div>
                                        </th>
                                        <th style={{ width: 50 }}>
                                            <div className="hv-th-title">
                                                <input type="checkbox" className="hv-th-check"
                                                    onChange={() => handleSelectAllChange('all')}
                                                />
                                            </div>
                                        </th>
                                    </tr>
                                )}

                                {activeTab === "counselor" && (
                                    <tr>
                                        <th style={{ width: 32, textAlign: "center" }}>#</th>
                                        <th style={{ width: 30 }}>
                                            <button type="button" className="hv-sort" onClick={handleSortByLocation}>Location</button>
                                            <br />
                                            <input className="hv-th-search hv-hide-on-print" placeholder="Search"
                                                value={searchByLocationName}
                                                onChange={(e) => setSearchByLocationName(e.target.value)}
                                            />
                                        </th>
                                        <th style={{ width: 50 }}>
                                            <button type="button" className="hv-sort" onClick={handleSortByDos}>DOS</button>
                                            <br />
                                            <input className="hv-th-search" placeholder="Search"
                                                value={searchByDOS}
                                                onChange={(e) => setSearchByDOS(e.target.value)} />
                                        </th>
                                        <th style={{ width: 50 }}>
                                            <div className="hv-th-title">App Time</div>
                                        </th>
                                        <th style={{ width: 50 }}>
                                            <div className="hv-th-title">Invoice#</div>
                                            <input className="hv-th-search hv-hide-on-print" placeholder="Search"
                                                value={searchByInvoice}
                                                onChange={(e) => setSearchByInvoice(e.target.value)}
                                            />
                                        </th>
                                        <th style={{ width: 60 }}>
                                            <button type="button" className="hv-sort" onClick={handleSortByPatname}>Patient Name</button>
                                            <br />
                                            <input className="hv-th-search" placeholder="Search"
                                                value={searchByPatient}
                                                onChange={(e) => setSearchByPatient(e.target.value)} />
                                        </th>
                                        <th style={{ width: 50 }}>
                                            <div className="hv-th-title">DOB</div>
                                            <input className="hv-th-search" placeholder="Search"
                                                value={searchByDOB}
                                                onChange={(e) => setSearchByDOB(e.target.value)} />
                                        </th>
                                        <th style={{ width: 100 }}>
                                            <div className="hv-th-title">Insurance</div>
                                            <input className="hv-th-search" placeholder="Search"
                                                value={searchByInsuranceID}
                                                onChange={(e) => setSearchByInsuranceID(e.target.value)} />
                                        </th>
                                        <th style={{ width: 90 }}>
                                            <div className="hv-th-title">
                                                Counselor
                                                <input type="checkbox" className="hv-th-check"
                                                    onChange={() => handleSelectCounselorAllChange('all')}
                                                />
                                            </div>
                                            <select name="select" className="hv-select hv-select--sm hv-hide-on-print" onChange={handleSelectFilterCounselor} value={selectedFilterCounselor}>
                                                <option value="">&lt;--Select--&gt;</option>
                                                {filteredCounselor.map(provider => (
                                                    <option key={provider.ProviderID} value={provider.ProviderID}>{provider.ProviderName}</option>
                                                ))}
                                            </select>
                                            <br />
                                            <input className="hv-th-search hv-hide-on-print" placeholder="Search"
                                                value={searchByCounselor}
                                                onChange={(e) => setSearchByCounselor(e.target.value)}
                                            />
                                        </th>
                                        <th style={{ width: 50, textAlign: "center" }}>
                                            <div className="hv-th-title">
                                                COU-CPT
                                                <input type="checkbox" className="hv-th-check"
                                                    onChange={() => handleSelectCouCPTAllChange('all')}
                                                />
                                            </div>
                                            <input className="hv-th-search hv-hide-on-print" placeholder="Search"
                                                value={searchByCouCPT}
                                                onChange={(e) => setSearchByCouCPT(e.target.value)}
                                            />
                                        </th>
                                        <th style={{ width: 60 }}>
                                            <div className="hv-th-title">Units</div>
                                        </th>
                                        <th style={{ width: 60 }}>
                                            <div className="hv-th-title">
                                                ICD
                                                <input type="checkbox" className="hv-th-check"
                                                    onChange={() => handleSelectDiag2AllChange('all')}
                                                />
                                            </div>
                                            <input className="hv-th-search hv-hide-on-print" placeholder="Search"
                                                value={searchByICD2}
                                                onChange={(e) => setSearchByICD2(e.target.value)}
                                            />
                                        </th>
                                        <th style={{ width: 60 }}>
                                            <div className="hv-th-title">
                                                Mod
                                                <input type="checkbox" className="hv-th-check"
                                                    onChange={() => handleSelectMod2AllChange('all')}
                                                />
                                            </div>
                                            <input className="hv-th-search hv-hide-on-print" placeholder="Search"
                                                value={searchByMod2}
                                                onChange={(e) => setSearchByMod2(e.target.value)}
                                            />
                                        </th>
                                        <th style={{ width: 50 }}>
                                            <div className="hv-th-title">Claim #</div>
                                        </th>
                                        <th style={{ width: 50 }}>
                                            <div className="hv-th-title">
                                                <input type="checkbox" className="hv-th-check"
                                                    onChange={() => handleSelectAllChange('all')}
                                                />
                                            </div>
                                        </th>
                                    </tr>
                                )}

                                {activeTab === "lab" && (
                                    <tr>
                                        <th style={{ width: 32, textAlign: "center" }}>#</th>
                                        <th style={{ width: 30 }}>
                                            <button type="button" className="hv-sort" onClick={handleSortByLocation}>Location</button>
                                            <br />
                                            <input className="hv-th-search hv-hide-on-print" placeholder="Search"
                                                value={searchByLocationName}
                                                onChange={(e) => setSearchByLocationName(e.target.value)}
                                            />
                                        </th>
                                        <th style={{ width: 50 }}>
                                            <button type="button" className="hv-sort" onClick={handleSortByDos}>DOS</button>
                                            <br />
                                            <input className="hv-th-search" placeholder="Search"
                                                value={searchByDOS}
                                                onChange={(e) => setSearchByDOS(e.target.value)} />
                                        </th>
                                        <th style={{ width: 50 }}>
                                            <div className="hv-th-title">App Time</div>
                                        </th>
                                        <th style={{ width: 50 }}>
                                            <div className="hv-th-title">Invoice#</div>
                                            <input className="hv-th-search hv-hide-on-print" placeholder="Search"
                                                value={searchByInvoice}
                                                onChange={(e) => setSearchByInvoice(e.target.value)}
                                            />
                                        </th>
                                        <th style={{ width: 60 }}>
                                            <button type="button" className="hv-sort" onClick={handleSortByPatname}>Patient Name</button>
                                            <br />
                                            <input className="hv-th-search" placeholder="Search"
                                                value={searchByPatient}
                                                onChange={(e) => setSearchByPatient(e.target.value)} />
                                        </th>
                                        <th style={{ width: 50 }}>
                                            <div className="hv-th-title">DOB</div>
                                            <input className="hv-th-search" placeholder="Search"
                                                value={searchByDOB}
                                                onChange={(e) => setSearchByDOB(e.target.value)} />
                                        </th>
                                        <th style={{ width: 100 }}>
                                            <div className="hv-th-title">Insurance</div>
                                            <input className="hv-th-search" placeholder="Search"
                                                value={searchByInsuranceID}
                                                onChange={(e) => setSearchByInsuranceID(e.target.value)} />
                                        </th>
                                        <th style={{ width: 90 }}>
                                            <div className="hv-th-title">
                                                Lab CPT
                                                <input type="checkbox" className="hv-th-check"
                                                    onChange={() => handleSelectProviderAllChange('all')}
                                                />
                                                <input type="checkbox" className="hv-th-check"
                                                    onChange={() => handleSelectLabCPTAllChange('all')}
                                                />
                                            </div>
                                            <input className="hv-th-search hv-hide-on-print" placeholder="Search"
                                                value={searchByLabCPT}
                                                onChange={(e) => setSearchByLabCPT(e.target.value)}
                                            />
                                        </th>
                                        <th style={{ width: 60 }}>
                                            <div className="hv-th-title">
                                                ICD
                                                <input type="checkbox" className="hv-th-check"
                                                    onChange={() => handleSelectDiag3AllChange('all')}
                                                />
                                            </div>
                                            <input className="hv-th-search hv-hide-on-print" placeholder="Search"
                                                value={searchByICD4}
                                                onChange={(e) => setSearchByICD4(e.target.value)}
                                            />
                                        </th>
                                        <th style={{ width: 50 }}>
                                            <div className="hv-th-title">Claim #</div>
                                        </th>
                                        <th style={{ width: 50 }}>
                                            <div className="hv-th-title">
                                                <input type="checkbox" className="hv-th-check"
                                                    onChange={() => handleSelectAllChange('all')}
                                                />
                                            </div>
                                        </th>
                                    </tr>
                                )}

                                {activeTab === "nurse" && (
                                    <tr>
                                        <th style={{ width: 32, textAlign: "center" }}>#</th>
                                        <th style={{ width: 30 }}>
                                            <button type="button" className="hv-sort" onClick={handleSortByLocation}>Location</button>
                                            <br />
                                            <input className="hv-th-search hv-hide-on-print" placeholder="Search"
                                                value={searchByLocationName}
                                                onChange={(e) => setSearchByLocationName(e.target.value)}
                                            />
                                        </th>
                                        <th style={{ width: 50 }}>
                                            <button type="button" className="hv-sort" onClick={handleSortByDos}>DOS</button>
                                            <br />
                                            <input className="hv-th-search" placeholder="Search"
                                                value={searchByDOS}
                                                onChange={(e) => setSearchByDOS(e.target.value)} />
                                        </th>
                                        <th style={{ width: 50 }}>
                                            <div className="hv-th-title">App Time</div>
                                        </th>
                                        <th style={{ width: 50 }}>
                                            <div className="hv-th-title">Invoice#</div>
                                            <input className="hv-th-search hv-hide-on-print" placeholder="Search"
                                                value={searchByInvoice}
                                                onChange={(e) => setSearchByInvoice(e.target.value)}
                                            />
                                        </th>
                                        <th style={{ width: 60 }}>
                                            <button type="button" className="hv-sort" onClick={handleSortByPatname}>Patient Name</button>
                                            <br />
                                            <input className="hv-th-search" placeholder="Search"
                                                value={searchByPatient}
                                                onChange={(e) => setSearchByPatient(e.target.value)} />
                                        </th>
                                        <th style={{ width: 50 }}>
                                            <div className="hv-th-title">DOB</div>
                                            <input className="hv-th-search" placeholder="Search"
                                                value={searchByDOB}
                                                onChange={(e) => setSearchByDOB(e.target.value)} />
                                        </th>
                                        <th style={{ width: 100 }}>
                                            <div className="hv-th-title">Insurance</div>
                                            <input className="hv-th-search" placeholder="Search"
                                                value={searchByInsuranceID}
                                                onChange={(e) => setSearchByInsuranceID(e.target.value)} />
                                        </th>
                                        <th style={{ width: 90 }}>
                                            <div className="hv-th-title">Nurse</div>
                                            <input className="hv-th-search hv-hide-on-print" placeholder="Search"
                                                value={searchByNurseName}
                                                onChange={(e) => setSearchByNurseName(e.target.value)}
                                            />
                                        </th>
                                        <th style={{ width: 50, textAlign: "center" }}>
                                            <div className="hv-th-title">Nurse-CPT</div>
                                            <input className="hv-th-search hv-hide-on-print" placeholder="Search"
                                                value={searchByNurseCPT}
                                                onChange={(e) => setSearchByNurseCPT(e.target.value)}
                                            />
                                        </th>
                                        <th style={{ width: 60 }}>
                                            <div className="hv-th-title">Units</div>
                                        </th>
                                        <th style={{ width: 60 }}>
                                            <div className="hv-th-title">
                                                ICD
                                                <input type="checkbox" className="hv-th-check"
                                                    onChange={() => handleSelectDiag4AllChange('all')}
                                                />
                                            </div>
                                        </th>
                                        <th style={{ width: 50 }}>
                                            <div className="hv-th-title">Claim #</div>
                                        </th>
                                        <th style={{ width: 50 }}>
                                            <div className="hv-th-title">
                                                <input type="checkbox" className="hv-th-check"
                                                    onChange={() => handleSelectAllChange('all')}
                                                />
                                            </div>
                                        </th>
                                    </tr>
                                )}

                                {activeTab === "all" && (
                                    <tr>
                                        <th style={{ width: 32, textAlign: "center" }}>#</th>
                                        <th style={{ width: 30 }}>
                                            <button type="button" className="hv-sort" onClick={handleSortByLocation}>Location</button>
                                            <br />
                                            <input className="hv-th-search hv-hide-on-print" placeholder="Search"
                                                value={searchByLocationName}
                                                onChange={(e) => setSearchByLocationName(e.target.value)}
                                            />
                                        </th>
                                        <th style={{ width: 50 }}>
                                            <button type="button" className="hv-sort" onClick={handleSortByDos}>DOS</button>
                                            <br />
                                            <input className="hv-th-search" placeholder="Search"
                                                value={searchByDOS}
                                                onChange={(e) => setSearchByDOS(e.target.value)} />
                                        </th>
                                        <th style={{ width: 50 }}>
                                            <div className="hv-th-title">App Time</div>
                                        </th>
                                        <th style={{ width: 50 }}>
                                            <div className="hv-th-title">Invoice#</div>
                                            <input className="hv-th-search hv-hide-on-print" placeholder="Search"
                                                value={searchByInvoice}
                                                onChange={(e) => setSearchByInvoice(e.target.value)}
                                            />
                                        </th>
                                        <th style={{ width: 60 }}>
                                            <button type="button" className="hv-sort" onClick={handleSortByPatname}>Patient Name</button>
                                            <br />
                                            <input className="hv-th-search" placeholder="Search"
                                                value={searchByPatient}
                                                onChange={(e) => setSearchByPatient(e.target.value)} />
                                        </th>
                                        <th style={{ width: 50 }}>
                                            <div className="hv-th-title">DOB</div>
                                            <input className="hv-th-search" placeholder="Search"
                                                value={searchByDOB}
                                                onChange={(e) => setSearchByDOB(e.target.value)} />
                                        </th>
                                        <th style={{ width: 100 }}>
                                            <div className="hv-th-title">Insurance</div>
                                            <input className="hv-th-search" placeholder="Search"
                                                value={searchByInsuranceID}
                                                onChange={(e) => setSearchByInsuranceID(e.target.value)} />
                                        </th>

                                        {/* ── Provider group ── */}
                                        <th style={{ width: 90 }}>
                                            <div className="hv-th-title">
                                                Provider
                                                <input type="checkbox" className="hv-th-check"
                                                    onChange={() => handleSelectProviderAllChange('all')}
                                                />
                                            </div>
                                            <select name="select" className="hv-select hv-select--sm hv-hide-on-print" onChange={handleSelectFilterProviders} value={selectedFilterProvider}>
                                                <option value="">&lt;--Select--&gt;</option>
                                                {filteredProviders.map(provider => (
                                                    <option key={provider.ProviderID} value={provider.ProviderID}>{provider.ProviderName}</option>
                                                ))}
                                            </select>
                                            <br />
                                            <input className="hv-th-search hv-hide-on-print" placeholder="Search"
                                                value={searchByProvider}
                                                onChange={(e) => setSearchByProvider(e.target.value)}
                                            />
                                        </th>
                                        <th style={{ width: 80, textAlign: "center" }}>
                                            <div className="hv-th-title">
                                                CPT
                                                <input type="checkbox" className="hv-th-check"
                                                    onChange={() => handleSelectCPTAllChange('all')}
                                                />
                                            </div>
                                            <input className="hv-th-search hv-hide-on-print" placeholder="Search"
                                                value={searchByCPT}
                                                onChange={(e) => setSearchByCPT(e.target.value)}
                                            />
                                        </th>
                                        <th style={{ width: 60 }}>
                                            <div className="hv-th-title">Units</div>
                                        </th>
                                        <th style={{ width: 60 }}>
                                            <div className="hv-th-title">
                                                ICD
                                                <input type="checkbox" className="hv-th-check"
                                                    onChange={() => handleSelectDiag1AllChange('all')}
                                                />
                                            </div>
                                            <input className="hv-th-search hv-hide-on-print" placeholder="Search"
                                                value={searchByICD1}
                                                onChange={(e) => setSearchByICD1(e.target.value)}
                                            />
                                        </th>
                                        <th style={{ width: 60 }}>
                                            <div className="hv-th-title">
                                                Mod
                                                <input type="checkbox" className="hv-th-check"
                                                    onChange={() => handleSelectMod1AllChange('all')}
                                                />
                                            </div>
                                            <input className="hv-th-search hv-hide-on-print" placeholder="Search"
                                                value={searchByMod1}
                                                onChange={(e) => setSearchByMod1(e.target.value)}
                                            />
                                        </th>

                                        {/* ── Counselor group ── */}
                                        <th style={{ width: 90 }}>
                                            <div className="hv-th-title">
                                                Counselor
                                                <input type="checkbox" className="hv-th-check"
                                                    onChange={() => handleSelectCounselorAllChange('all')}
                                                />
                                            </div>
                                            <select name="select" className="hv-select hv-select--sm hv-hide-on-print" onChange={handleSelectFilterCounselor} value={selectedFilterCounselor}>
                                                <option value="">&lt;--Select--&gt;</option>
                                                {filteredCounselor.map(provider => (
                                                    <option key={provider.ProviderID} value={provider.ProviderID}>{provider.ProviderName}</option>
                                                ))}
                                            </select>
                                            <br />
                                            <input className="hv-th-search hv-hide-on-print" placeholder="Search"
                                                value={searchByCounselor}
                                                onChange={(e) => setSearchByCounselor(e.target.value)}
                                            />
                                        </th>
                                        <th style={{ width: 50, textAlign: "center" }}>
                                            <div className="hv-th-title">
                                                COU-CPT
                                                <input type="checkbox" className="hv-th-check"
                                                    onChange={() => handleSelectCouCPTAllChange('all')}
                                                />
                                            </div>
                                            <input className="hv-th-search hv-hide-on-print" placeholder="Search"
                                                value={searchByCouCPT}
                                                onChange={(e) => setSearchByCouCPT(e.target.value)}
                                            />
                                        </th>
                                        <th style={{ width: 60 }}>
                                            <div className="hv-th-title">Units</div>
                                        </th>
                                        <th style={{ width: 60 }}>
                                            <div className="hv-th-title">
                                                ICD
                                                <input type="checkbox" className="hv-th-check"
                                                    onChange={() => handleSelectDiag2AllChange('all')}
                                                />
                                            </div>
                                            <input className="hv-th-search hv-hide-on-print" placeholder="Search"
                                                value={searchByICD2}
                                                onChange={(e) => setSearchByICD2(e.target.value)}
                                            />
                                        </th>
                                        <th style={{ width: 60 }}>
                                            <div className="hv-th-title">
                                                Mod
                                                <input type="checkbox" className="hv-th-check"
                                                    onChange={() => handleSelectMod2AllChange('all')}
                                                />
                                            </div>
                                            <input className="hv-th-search hv-hide-on-print" placeholder="Search"
                                                value={searchByMod2}
                                                onChange={(e) => setSearchByMod2(e.target.value)}
                                            />
                                        </th>

                                        {/* ── Lab group ── */}
                                        <th style={{ width: 90 }}>
                                            <div className="hv-th-title">
                                                Lab CPT
                                                <input type="checkbox" className="hv-th-check"
                                                    onChange={() => handleSelectLabCPTAllChange('all')}
                                                />
                                            </div>
                                            <input className="hv-th-search hv-hide-on-print" placeholder="Search"
                                                value={searchByLabCPT}
                                                onChange={(e) => setSearchByLabCPT(e.target.value)}
                                            />
                                        </th>
                                        <th style={{ width: 60 }}>
                                            <div className="hv-th-title">
                                                ICD
                                                <input type="checkbox" className="hv-th-check"
                                                    onChange={() => handleSelectDiag3AllChange('all')}
                                                />
                                            </div>
                                            <input className="hv-th-search hv-hide-on-print" placeholder="Search"
                                                value={searchByICD4}
                                                onChange={(e) => setSearchByICD4(e.target.value)}
                                            />
                                        </th>

                                        {/* ── Nurse group ── */}
                                        <th style={{ width: 90 }}>
                                            <div className="hv-th-title">Nurse</div>
                                            <input className="hv-th-search hv-hide-on-print" placeholder="Search"
                                                value={searchByNurseName}
                                                onChange={(e) => setSearchByNurseName(e.target.value)}
                                            />
                                        </th>
                                        <th style={{ width: 50, textAlign: "center" }}>
                                            <div className="hv-th-title">Nurse-CPT</div>
                                            <input className="hv-th-search hv-hide-on-print" placeholder="Search"
                                                value={searchByNurseCPT}
                                                onChange={(e) => setSearchByNurseCPT(e.target.value)}
                                            />
                                        </th>
                                        <th style={{ width: 60 }}>
                                            <div className="hv-th-title">Units</div>
                                        </th>
                                        <th style={{ width: 60 }}>
                                            <div className="hv-th-title">
                                                ICD
                                                <input type="checkbox" className="hv-th-check"
                                                    onChange={() => handleSelectDiag4AllChange('all')}
                                                />
                                            </div>
                                        </th>

                                        {/* ── Shared ── */}
                                        <th style={{ width: 50 }}>
                                            <div className="hv-th-title">Claim #</div>
                                        </th>
                                        <th style={{ width: 50 }}>
                                            <div className="hv-th-title">
                                                <input type="checkbox" className="hv-th-check"
                                                    onChange={() => handleSelectAllChange('all')}
                                                />
                                            </div>
                                        </th>
                                    </tr>
                                )}
                            </thead>

                            <tbody>
                                {filteredTableDetails.map((item, index) => {
                                    // Pagination limits which rows render, but `index` still
                                    // means "position in filteredTableDetails" — every
                                    // checkbox/select-all handler below keys off that, so
                                    // skipping render here (instead of slicing the array)
                                    // keeps their behavior identical to before pagination.
                                    if (index < pageStart || index >= pageEnd) return null;

                                    const invalid = item.DataValidationMessage && item.DataValidationMessage.trim() !== "";

                                    const patientCell = (
                                        <>
                                            <td>
                                                <span className="hv-td-muted">
                                                    {item.fromTimeAMPM}
                                                </span>
                                            </td>

                                            <td>
                                                <span className="hv-td-muted">
                                                    {item.PracticeInvoiceNumber}
                                                </span>
                                            </td>
                                            <td>
                                                <button type="button" className="hv-td-link" onClick={() => handlePatLinkClick(item)}>
                                                    {item.PatientName}
                                                </button>
                                            </td>
                                        </>
                                    );

                                    return (
                                        <tr
                                            key={index}
                                            title={item.DataValidationMessage || ""}
                                            className={`${invalid ? "is-invalid" : ""} ${activeRow === index ? "is-selected" : ""}`}
                                            onClick={() => setActiveRow(index)}
                                        >
                                            {activeTab === "provider" && (
                                                <>
                                                    <td>{index + 1}</td>
                                                    <td>{item.LocationName}</td>
                                                    <td>
                                                        <span className="hv-td-muted">
                                                            {fmtDate(item.DOS)}
                                                        </span>
                                                    </td>

                                                    {patientCell}
                                                    <td>{fmtDate(item.DOB)}</td>
                                                    <td>
                                                        {item.Insurance ? item.Insurance : <FontAwesomeIcon className="hv-t-red" icon={faStar} />}
                                                    </td>

                                                    <td>
                                                        {item.FinalProviderName}
                                                        {(item.PrEncSusingoff == 1 || item.ProEncAssSignoff == 1) ? (
                                                            <FontAwesomeIcon className="hv-t-red hv-hide-on-print" style={{ marginLeft: '5px', cursor: 'pointer' }} onClick={() => GetProviderPDF(item)} icon={faFilePdf} />
                                                        ) : null}
                                                        <input type="checkbox"
                                                            checked={providerAllCheckbox.includes(index)}
                                                            onChange={() => handleProviderRowCheckboxChange(index, item)}
                                                        />
                                                    </td>
                                                    <td>
                                                        {(item.ProEncAssSignoff === null || item.ProEncAssSignoff === '0') ? null : (
                                                            <FontAwesomeIcon icon={faCircleCheck} className="hv-t-teal hv-hide-on-print" />
                                                        )}
                                                        {(item.PrEncSusingoff === null || item.PrEncSusingoff === '0') ? null : (
                                                            <FontAwesomeIcon icon={faCircleCheck} className="hv-t-green hv-hide-on-print" />
                                                        )}
                                                        {item.ProviderCPT}
                                                        <input type="checkbox"
                                                            checked={cptAllCheckbox.includes(index)}
                                                            onChange={() => handleCPTRowCheckboxChange(index)}
                                                        />
                                                    </td>

                                                    <td>{item.ProviderCPTUnits}</td>
                                                    <td>
                                                        {item.ICD}
                                                        <input type="checkbox"
                                                            checked={diag1AllCheckbox.includes(index)}
                                                            onChange={() => handleDiag1RowCheckboxChange(index)}
                                                        />
                                                    </td>

                                                    <td>
                                                        {item.Modifier}
                                                        <input type="checkbox"
                                                            checked={mod1AllCheckbox.includes(index)}
                                                            onChange={() => handleMod1RowCheckboxChange(index)}
                                                        />
                                                    </td>
                                                    <td>
                                                        <button type="button" className="hv-td-link" onClick={() => handleLinkClick(item)}>
                                                            {item.ClaimID}
                                                        </button>
                                                    </td>
                                                    <td>
                                                        <input
                                                            type="checkbox"
                                                            checked={selectedRows.includes(index)}
                                                            onChange={() => handleRowCheckboxChange(index)}
                                                        />
                                                    </td>
                                                </>
                                            )}

                                            {activeTab === "counselor" && (
                                                <>
                                                    <td>{index + 1}</td>
                                                    <td>{item.LocationName}</td>
                                                    <td>
                                                        <span className="hv-td-muted">
                                                            {fmtDate(item.DOS)}
                                                        </span>
                                                    </td>

                                                    {patientCell}
                                                    <td>{fmtDate(item.DOB)}</td>
                                                    <td>
                                                        {item.Insurance ? item.Insurance : <FontAwesomeIcon className="hv-t-red" icon={faStar} />}
                                                    </td>

                                                    <td>
                                                        {item.CounselorName}
                                                        {item.SupervisorSignedoffForms == 1 || item.AssistantSignedoffForms != 0 ? (
                                                            <FontAwesomeIcon className="hv-t-red hv-hide-on-print" style={{ marginLeft: '5px', cursor: 'pointer' }} onClick={() => GetProviderPDF(item)} icon={faFilePdf} />
                                                        ) : null}
                                                        <input type="checkbox"
                                                            checked={counselorAllCheckbox.includes(index)}
                                                            onChange={() => handleCounselorRowCheckboxChange(index)}
                                                        />
                                                    </td>
                                                    <td>
                                                        {item.AssistantSignedoffForms == 0 ? null : (
                                                            <FontAwesomeIcon icon={faCircleCheck} className="hv-t-teal hv-hide-on-print" />
                                                        )}
                                                        {item.SupervisorSignedoffForms == 0 ? null : (
                                                            <FontAwesomeIcon icon={faCircleCheck} className="hv-t-green hv-hide-on-print" />
                                                        )}
                                                        <br />
                                                        {item.CouCPT}
                                                        <input type="checkbox"
                                                            checked={couCPTAllCheckbox.includes(index)}
                                                            onChange={() => handleCouCPTRowCheckboxChange(index)}
                                                        />
                                                    </td>

                                                    <td>{item.CounselorCPTUnits}</td>
                                                    <td>
                                                        {/* print-label: read by handlePrint()'s own embedded
                                                            stylesheet (a separate popup document, outside the
                                                            hv- system) to wrap/shrink this column when printed. */}
                                                        <span className="print-label">{item.CouICD}</span>
                                                        <input type="checkbox"
                                                            checked={diag2AllCheckbox.includes(index)}
                                                            onChange={() => handleDiag2RowCheckboxChange(index)}
                                                        />
                                                    </td>

                                                    <td>
                                                        {item.CouModifier}
                                                        <input type="checkbox"
                                                            checked={mod2AllCheckbox.includes(index)}
                                                            onChange={() => handleMod2RowCheckboxChange(index)}
                                                        />
                                                    </td>
                                                    <td>
                                                        <button type="button" className="hv-td-link" onClick={() => handleLinkClick(item)}>
                                                            {item.ClaimID}
                                                        </button>
                                                    </td>
                                                    <td>
                                                        <input
                                                            type="checkbox"
                                                            checked={selectedRows.includes(index)}
                                                            onChange={() => handleRowCheckboxChange(index)}
                                                        />
                                                    </td>
                                                </>
                                            )}

                                            {activeTab === "lab" && (
                                                <>
                                                    <td>{index + 1}</td>
                                                    <td>{item.LocationName}</td>
                                                    <td>
                                                        <span className="hv-td-muted">
                                                            {fmtDate(item.DOS)}
                                                        </span>
                                                    </td>

                                                    {patientCell}
                                                    <td>{fmtDate(item.DOB)}</td>
                                                    <td>
                                                        {item.Insurance ? item.Insurance : <FontAwesomeIcon className="hv-t-red" icon={faStar} />}
                                                    </td>

                                                    <td>
                                                        {item.LabCPT}
                                                        <input type="checkbox"
                                                            checked={labCPTAllCheckbox.includes(index)}
                                                            onChange={() => handleLabCPTRowCheckboxChange(index)}
                                                        />
                                                    </td>
                                                    <td>
                                                        {item.LabICD}
                                                        <input type="checkbox"
                                                            checked={diag3AllCheckbox.includes(index)}
                                                            onChange={() => handleDiag3RowCheckboxChange(index)}
                                                        />
                                                    </td>
                                                    <td>
                                                        <button type="button" className="hv-td-link" onClick={() => handleLinkClick(item)}>
                                                            {item.ClaimID}
                                                        </button>
                                                    </td>
                                                    <td>
                                                        <input
                                                            type="checkbox"
                                                            checked={selectedRows.includes(index)}
                                                            onChange={() => handleRowCheckboxChange(index)}
                                                        />
                                                    </td>
                                                </>
                                            )}

                                            {activeTab === "nurse" && (
                                                <>
                                                    <td>{index + 1}</td>
                                                    <td>{item.LocationName}</td>
                                                    <td>
                                                        <span className="hv-td-muted">
                                                            {fmtDate(item.DOS)}
                                                        </span>
                                                    </td>

                                                    {patientCell}
                                                    <td>{fmtDate(item.DOB)}</td>
                                                    <td>
                                                        {item.Insurance ? item.Insurance : <FontAwesomeIcon className="hv-t-red" icon={faStar} />}
                                                    </td>

                                                    <td>{item.NurseName}</td>
                                                    <td>{item.NurseCPT}</td>

                                                    <td>{item.NurseCPTUnits}</td>

                                                    <td>
                                                        {item.NurseICD}
                                                        <input type="checkbox"
                                                            checked={diag4AllCheckbox.includes(index)}
                                                            onChange={() => handleDiag4RowCheckboxChange(index)}
                                                        />
                                                    </td>
                                                    <td>
                                                        <button type="button" className="hv-td-link" onClick={() => handleLinkClick(item)}>
                                                            {item.ClaimID}
                                                        </button>
                                                    </td>
                                                    <td>
                                                        <input
                                                            type="checkbox"
                                                            checked={selectedRows.includes(index)}
                                                            onChange={() => handleRowCheckboxChange(index)}
                                                        />
                                                    </td>
                                                </>
                                            )}

                                            {activeTab === "all" && (
                                                <>
                                                    <td>{index + 1}</td>
                                                    <td>{item.LocationName}</td>
                                                    <td>
                                                        <span className="hv-td-muted">
                                                            {fmtDate(item.DOS)}
                                                        </span>
                                                    </td>

                                                    {patientCell}
                                                    <td>{fmtDate(item.DOB)}</td>
                                                    <td>
                                                        {item.Insurance ? item.Insurance : <FontAwesomeIcon className="hv-t-red" icon={faStar} />}
                                                    </td>

                                                    {/* ── Provider group ── */}
                                                    <td>
                                                        {item.FinalProviderName}
                                                        {(item.PrEncSusingoff == 1 || item.ProEncAssSignoff == 1) ? (
                                                            <FontAwesomeIcon className="hv-t-red hv-hide-on-print" style={{ marginLeft: '5px', cursor: 'pointer' }} onClick={() => GetProviderPDF(item)} icon={faFilePdf} />
                                                        ) : null}
                                                        <input type="checkbox"
                                                            checked={providerAllCheckbox.includes(index)}
                                                            onChange={() => handleProviderRowCheckboxChange(index, item)}
                                                        />
                                                    </td>
                                                    <td>
                                                        {(item.ProEncAssSignoff === null || item.ProEncAssSignoff === '0') ? null : (
                                                            <FontAwesomeIcon icon={faCircleCheck} className="hv-t-teal hv-hide-on-print" />
                                                        )}
                                                        {(item.PrEncSusingoff === null || item.PrEncSusingoff === '0') ? null : (
                                                            <FontAwesomeIcon icon={faCircleCheck} className="hv-t-green hv-hide-on-print" />
                                                        )}
                                                        {item.ProviderCPT}
                                                        <input type="checkbox"
                                                            checked={cptAllCheckbox.includes(index)}
                                                            onChange={() => handleCPTRowCheckboxChange(index)}
                                                        />
                                                    </td>
                                                    <td>{item.ProviderCPTUnits}</td>
                                                    <td>
                                                        {item.ICD}
                                                        <input type="checkbox"
                                                            checked={diag1AllCheckbox.includes(index)}
                                                            onChange={() => handleDiag1RowCheckboxChange(index)}
                                                        />
                                                    </td>
                                                    <td>
                                                        {item.Modifier}
                                                        <input type="checkbox"
                                                            checked={mod1AllCheckbox.includes(index)}
                                                            onChange={() => handleMod1RowCheckboxChange(index)}
                                                        />
                                                    </td>

                                                    {/* ── Counselor group ── */}
                                                    <td>
                                                        {item.CounselorName}
                                                        {item.SupervisorSignedoffForms == 1 || item.AssistantSignedoffForms != 0 ? (
                                                            <FontAwesomeIcon className="hv-t-red hv-hide-on-print" style={{ marginLeft: '5px', cursor: 'pointer' }} onClick={() => GetProviderPDF(item)} icon={faFilePdf} />
                                                        ) : null}
                                                        <input type="checkbox"
                                                            checked={counselorAllCheckbox.includes(index)}
                                                            onChange={() => handleCounselorRowCheckboxChange(index)}
                                                        />
                                                    </td>
                                                    <td>
                                                        {item.AssistantSignedoffForms == 0 ? null : (
                                                            <FontAwesomeIcon icon={faCircleCheck} className="hv-t-teal hv-hide-on-print" />
                                                        )}
                                                        {item.SupervisorSignedoffForms == 0 ? null : (
                                                            <FontAwesomeIcon icon={faCircleCheck} className="hv-t-green hv-hide-on-print" />
                                                        )}
                                                        <br />
                                                        {item.CouCPT}
                                                        <input type="checkbox"
                                                            checked={couCPTAllCheckbox.includes(index)}
                                                            onChange={() => handleCouCPTRowCheckboxChange(index)}
                                                        />
                                                    </td>
                                                    <td>{item.CounselorCPTUnits}</td>
                                                    <td>
                                                        <span className="print-label">{item.CouICD}</span>
                                                        <input type="checkbox"
                                                            checked={diag2AllCheckbox.includes(index)}
                                                            onChange={() => handleDiag2RowCheckboxChange(index)}
                                                        />
                                                    </td>
                                                    <td>
                                                        {item.CouModifier}
                                                        <input type="checkbox"
                                                            checked={mod2AllCheckbox.includes(index)}
                                                            onChange={() => handleMod2RowCheckboxChange(index)}
                                                        />
                                                    </td>

                                                    {/* ── Lab group ── */}
                                                    <td>
                                                        {item.LabCPT}
                                                        <input type="checkbox"
                                                            checked={labCPTAllCheckbox.includes(index)}
                                                            onChange={() => handleLabCPTRowCheckboxChange(index)}
                                                        />
                                                    </td>
                                                    <td>
                                                        {item.LabICD}
                                                        <input type="checkbox"
                                                            checked={diag3AllCheckbox.includes(index)}
                                                            onChange={() => handleDiag3RowCheckboxChange(index)}
                                                        />
                                                    </td>

                                                    {/* ── Nurse group ── */}
                                                    <td>{item.NurseName}</td>
                                                    <td>{item.NurseCPT}</td>
                                                    <td>{item.NurseCPTUnits}</td>
                                                    <td>
                                                        {item.NurseICD}
                                                        <input type="checkbox"
                                                            checked={diag4AllCheckbox.includes(index)}
                                                            onChange={() => handleDiag4RowCheckboxChange(index)}
                                                        />
                                                    </td>

                                                    {/* ── Shared ── */}
                                                    <td>
                                                        <button type="button" className="hv-td-link" onClick={() => handleLinkClick(item)}>
                                                            {item.ClaimID}
                                                        </button>
                                                    </td>
                                                    <td>
                                                        <input
                                                            type="checkbox"
                                                            checked={selectedRows.includes(index)}
                                                            onChange={() => handleRowCheckboxChange(index)}
                                                        />
                                                    </td>
                                                </>
                                            )}
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>

                        {loading && (
                            <div className="hv-loading-overlay">
                                <div className="hv-loader" role="status" aria-live="polite">
                                    <div className="hv-loader__coins" aria-hidden="true">
                                        <span>🪙</span>
                                        <span>💵</span>
                                        <span>🧾</span>
                                    </div>
                                    <div className="hv-loader__bar">
                                        <div className="hv-loader__bar-fill" />
                                    </div>
                                    <div className="hv-loader__title">Healthiva is on it…</div>
                                    <div className="hv-loader__quip" />
                                </div>
                            </div>
                        )}
                    </div>

                    {totalPages > 1 && (
                        <div className="hv-tablebar">
                            <span className="hv-t-sm hv-t-semi hv-t-muted">
                                {filteredTableDetails.length === 0
                                    ? "0 of 0"
                                    : `${pageStart + 1}–${Math.min(pageEnd, filteredTableDetails.length)} of ${filteredTableDetails.length}`}
                            </span>
                            <div className="hv-pagi">
                                <button
                                    type="button"
                                    className="hv-pagi__btn"
                                    disabled={currentPage === 1}
                                    onClick={() => setCurrentPage((p) => Math.max(1, p - 1))}
                                    aria-label="Previous page"
                                >
                                    ‹
                                </button>
                                {Array.from({ length: totalPages }, (_, i) => i + 1).map((p) => (
                                    <button
                                        key={p}
                                        type="button"
                                        className={`hv-pagi__btn ${p === currentPage ? "is-active" : ""}`}
                                        onClick={() => setCurrentPage(p)}
                                        aria-current={p === currentPage ? "page" : undefined}
                                    >
                                        {p}
                                    </button>
                                ))}
                                <button
                                    type="button"
                                    className="hv-pagi__btn"
                                    disabled={currentPage === totalPages}
                                    onClick={() => setCurrentPage((p) => Math.min(totalPages, p + 1))}
                                    aria-label="Next page"
                                >
                                    ›
                                </button>
                            </div>
                        </div>
                    )}
                </section>

                {showSelectErrorModal && (
                    <>
                        <div className="hv-scrim" onClick={handleCloseModals} />
                        <div className="hv-modal">
                            <div className="hv-modal__box">
                                <div className="hv-modal__head hv-modal__head--warn">
                                    <span className="hv-modal__title">Selection required</span>
                                </div>
                                <div className="hv-modal__body">
                                    <p>Select one or more files to generate claims by selecting the check box!!</p>
                                </div>
                                <div className="hv-modal__foot">
                                    <button className="hv-btn hv-btn--primary" onClick={handleCloseModals}>Ok</button>
                                </div>
                            </div>
                        </div>
                    </>
                )}

                {showSuccessModal && (
                    <>
                        <div className="hv-scrim" onClick={handleCloseModals} />
                        <div className="hv-modal">
                            <div className="hv-modal__box">
                                <div className="hv-modal__head hv-modal__head--ok">
                                    <span className="hv-modal__title">{`${savedRowCount} Claim Generated`}</span>
                                    <button className="hv-modal__close" onClick={handleCloseModals}>
                                        <FontAwesomeIcon icon={faXmark} />
                                    </button>
                                </div>
                            </div>
                        </div>
                    </>
                )}

                {showDeleteModal && (
                    <>
                        <div className="hv-scrim" onClick={handleCloseModals} />
                        <div className="hv-modal">
                            <div className="hv-modal__box">
                                <div className="hv-modal__head hv-modal__head--ok">
                                    <span className="hv-modal__title">Delete</span>
                                </div>
                                <div className="hv-modal__body">
                                    <p>{`${savedRowCount} claim successfully Saved`}</p>
                                </div>
                                <div className="hv-modal__foot">
                                    <button className="hv-btn hv-btn--ghost" onClick={handleCloseModals}>Close</button>
                                    <button className="hv-btn hv-btn--danger" onClick={handleDelete}>Delete</button>
                                </div>
                            </div>
                        </div>
                    </>
                )}

                {showPopup && (
                    <div className="hv-toasts">
                        <div className="hv-toast">
                            <div className="hv-toast__body">{popupMessage}</div>
                        </div>
                    </div>
                )}

            </div>
        </div>
    )
}

export default SuperBill;
